// 西班牙语
import esLocale from 'element-ui/lib/locale/lang/es'


const es = {
  // ============== 登陆页 start=============
  "登录": "Iniciar sesión",
  "退出": "Cerrar sesión",
  "账号": "Cuenta",
  "密码": "Contraseña",
  "验证码": "Código de verificación",
  "请输入账号": "Por favor ingrese su cuenta",
  "请输入密码": "Por favor ingrese su contraseña",
  "请输入验证码": "Por favor ingrese el código de verificación",
  "验证码不正确": "Código de verificación incorrecto",
  "没有账号": "Sin cuenta",
  "请": "Por favor",
  "点击注册": "Haga clic para registrarse",
  // ============== 登陆页 end  =============
  // =========== 首页 start==================
  "门店总量": "Total de Tiendas",
  "用户总量": "Cantidad Total de Usuarios",
  "营业总量": "Total de Volumen de Negocios",
  "订单总量": "Volumen Total de Pedidos",
  "商品总量": "Cantidad Total de Inventario",
  "销售总额": "Total de Ventas",
  "元": "€",
  "预计收入": "Ingresos Estimados",
  "今日概况": "Resumen del Día",
  "销售额": "Volumen de Ventas",
  "支付订单数": "Pedidos Pagados",
  "昨日": "Ayer",
  "新增用户数": "Nuevos Usuarios",
  "新增商户": "Nuevos Comerciantes",
  "下单用户数": "Usuarios que Realizaron Pedidos",
  "待办事项": "Tareas Pendientes",
  "请尽快处理，以免影响营业": "Por favor, abórdelo rápidamente para evitar impactos en el negocio",
  "待处理订单": "órdenes en Proceso",
  "库存告急": "Emergencia de Inventario",
  "商品排行榜": "Ranking de Productos Principales",
  "销量": "Volumen de Ventas",
  "暂无上榜记录": "No hay Registros de Clasificación en el Momento",
  "成交额": "Volumen de Transacciones",
  "成交量": "órdenes de Transacción",
  "退单额": "Volumen Total de Reembolsos",
  "退单量": "órdenes de Reembolsos",
  // =========== 首页 end==================
  // =========== 建店必做 start=============
  "基本资料": "Información Básica",
  "编辑门店": "Editar Tienda",
  "官方网站": "Sitio Web Oficial",
  "门店服务": "Servicios de la Tienda",
  "服务与营业时间": "Servicios y Horarios de Negocio",
  "桌码管理": "Gestión de Códigos de Mesa",
  "收银台": "Caja Registradora",
  "后厨": "Cocina",
  "商品": "Mercancía",
  "商品分类": "Clasificación de Mercancías",
  "添加商品": "Agregar Mercancía",
  "网站": "Sitio Web",
  "网站编辑": "Edición de Sitio Web",
  "资讯": "Información",
  "上一步": "Paso Anterior",
  "保存": "Guardar",
  "下一步": "Siguiente Paso",
  "提交失败": "Falló la Presentación",
  "获取当前进度信息失败": "Fallo al Obtener la Información de Progreso Actual",
  "门店名称": "Nombre de la Tienda",
  "请输入门店名称": "Por favor ingrese el nombre de la tienda",
  "登录密码": "Contraseña de Inicio de Sesión",
  "请输入登录密码": "Por favor ingrese la ontraseña de inicio de sesión",
  "确认密码": "Confirmar Contraseña",
  "请输入确认密码": "Por favor ingrese la confirmación de Contraseña",
  "联系人": "Contacto",
  "请输入联系人": "Por favor ingrese el nombre de contacto",
  "联系电话": "Teléfono de Contacto",
  "请输入联系电话": "Por favor ingrese el teléfono de contacto",
  "店铺类型": "Tipo de Tienda",
  "分店": "Sucursal",
  "直营": "Venta Directa",
  "同步主店": "Sincronizar con la Tienda Principal",
  "分店创建": "Creación de Sucursal",
  "温馨提示：选择后，请勿随意修改，以免造成门店商品数据错乱": "Recordatorio Amable: Después de elegir, por favor no modifique al azar para evitar confusiones en los datos de la mercancía de la tienda",
  "绑定用户": "Vincular Usuario",
  "选择用户": "Seleccionar Usuario",
  "用户昵称": "Alias de Usuario",
  "门店logo": "Logo de la Tienda",
  "选择图片": "Seleccionar Imagen",
  "地址": "Dirección",
  "请输入地址": "Por favor ingrese la dirección",
  "门店坐标": "Coordenadas de la Tienda",
  "商家介绍": "Introducción del Comerciante",
  "状态": "Estado",
  "开启": "Abrir",
  "禁止": "Cerrar",
  "营业状态": "Estado de Negocio",
  "营业中": "Abierto",
  "停止营业": "Cerrado",
  "上传图片": "Subir Imagen",
  "获取当前门店失败，请刷新界面重试": "Error al obtener la tienda actual, por favor actualice la página e inténtelo de nuevo",
  "商城设置": "Configuración del Centro Comercial",
  "商城名称": "Nombre del Centro Comercial",
  "商城名称不能为空": "El Nombre del Centro Comercial no Puede Estar Vacío",
  "访问网址后缀": "Sufijo de la URL de Visita",
  "访问网址": "Visitar URL",
  "手机网站": "Sitio Web Móvil",
  "默认": "Predeterminado",
  "自定义": "Personalizado",
  "Pad点餐网站": "Sitio Web de Pedido en Pad",
  "收银台网站": "Sitio Web de Caja Registradora",
  "后厨网站": "Sitio Web de Cocina",
  "会员设置": "Configuración de Miembros",
  "请选择默认头像": "Por favor seleccione un avatar predeterminado",
  "门店二维码": "Código QR de la Tienda",
  "下载": "Descargar",
  "营业时间": "Horario de Negocio",
  "店内营业时间": "Horario de Negocio en el Local",
  "请选择店内营业时间": "Por favor seleccione el horario de negocio en el local",
  "开始时间": "Hora de Inicio",
  "结束时间": "Hora de Finalización",
  "至": "A",
  "选择时间范围": "Seleccionar Rango de Tiempo",
  "自提营业时间": "Horario de Negocio de Recogida Personal",
  "请选择自提营业时间": "Por favor seleccione el horario de negocio de recogida personal",
  "外卖营业时间": "Horario de Negocio de Entrega a Domicilio",
  "请选择外卖营业时间": "Por favor seleccione el horario de negocio de entrega a domicilio",
  "外卖配送": "Entrega a Domicilio",
  "注": "Nota",
  "外卖配送方式至少选择一个": "Debe seleccionar al menos un método de entrega a domicilio",
  "店内配置": "Configuración del Local",
  "店内用餐方式至少选择一个": "Debes seleccionar al menos un método de comedor en el local",
  "堂食服务": "Servicio de Comedor en el Local",
  "店内堂食结算模式": "Modo de Liquidación de Comedor en el Local",
  "先结账后用餐": "Pagar Primero, Luego Comer",
  "先用餐后结账": "Comer Primero, Luego Pagar",
  "收银台桌台清台设置": "Configuración de Limpieza de Mesa de la Caja Registradora",
  "定时清台": "Limpieza de Mesa Programada",
  "立即清台": "Limpiar la Mesa de Inmediato",
  "开启定时清台后，系统将在设置的时间后自动清除收银台点餐的桌台，此功能仅在餐前付款模式下生效": "Al activar la limpieza de la mesa programada, el sistema limpiará automáticamente la mesa de pedidos de la caja registradora después del tiempo establecido. Esta función solo funciona en el modo de pago antes de la comida",
  "桌台订单清台设置": "Configuración de Limpieza de Mesa de Pedidos",
  "分钟后自动清理桌台（扫桌码点餐和收银桌台点餐定时清台时间）": "Limpiar automáticamente la mesa minutos más tarde (tiempo de limpieza de mesa programado para escaneo de códigos de mesa y pedidos de caja registradora)",
  "店内堂食服务费": "Tarifa de Servicio de Comedor en el Local",
  "按就餐人数收取": "Cobrar según el número de comensales",
  "按每桌台收取": "Cobrar por mesa",
  "请输入服务费": "Por favor ingrese la tarifa de servicio",
  "位": "Asiento",
  "桌": "Mesa",
  "店内包装费类型": "Tipo de Tarifa de Envoltura en el Local",
  "按商品收费": "Cobrar según la mercancía",
  "按单收费": "Cobrar por pedido",
  "包装费": "Tarifa de Envoltura",
  "请输入包装费": "Por favor ingrese la tarifa de envoltura",
  "外卖服务": "Servicio de Entrega a Domicilio",
  "外卖包装费类型": "Tipo de Tarifa de Envoltura para Entrega a Domicilio",
  "外卖配送范围": "Rango de Entrega a Domicilio",
  "请输入外卖配送范围": "Por favor ingrese el rango de entrega a domicilio",
  "外卖配送费": "Tarifa de Entrega a Domicilio",
  "请输入外卖配送费": "Por favor ingrese la tarifa de entrega a domicilio",
  "最低消费": "Consumo Mínimo",
  "请输入最低消费": "Por favor ingrese el consumo mínimo",
  "添加类型": "Agregar Tipo",
  "排序": "Orden",
  "类型名称": "Nombre del Tipo",
  "人数区间": "Rango de Número de Personas",
  "添加时间": "Agregar Tiempo",
  "操作": "Operación",
  "删除": "Eliminar",
  "桌位管理": "Gestión de Mesas",
  "最少人数": "Número Mínimo de Personas",
  "最多人数": "Número Máximo de Personas",
  "取 消": "Cancelar",
  "确 定": "Confirmar",
  "请输入类型名称": "Por favor ingrese el nombre del tipo",
  "排序不能为空": "El Orden no Puede Estar Vacío",
  "排序必须为数字": "El Orden Debe Ser un Número",
  "添加成功": "Agregado Exitosamente",
  "修改类型": "Modificar Tipo",
  "修改成功": "Modificado Exitosamente",
  "添加区域": "Agregar área",
  "区域名称": "Nombre del área",
  "修改区域": "Modificar área",
  "请输入区域名称": "Por favor ingrese el nombre del área",
  "分类名称": "Nombre de la Categoría",
  "编号": "Número",
  "选择区域": "Seleccionar área",
  "请选择": "Por favor seleccione",
  "选择类型": "Seleccionar Tipo",
  "查询": "Buscar",
  "桌号id": "ID de Mesa",
  "所属区域": "área de Pertenencia",
  "桌位类型": "Tipo de Mesa",
  "桌位编码": "Código de Mesa",
  "人": "Personas",
  "二维码": "Código QR",
  "桌位编号": "Número de Mesa",
  "请输入桌位编号": "Por favor ingrese el número de mesa",
  "请选择类型名称": "Por favor seleccione el nombre del tipo",
  "请选择所属区域": "Por favor seleccione la área de pertenencia",
  "添加桌位": "Agregar Mesa",
  "关键词": "Palabra Clave",
  "添加收银员": "Agregar Cajero",
  "姓名": "Nombre",
  "登录账号": "Cuenta de Inicio de Sesión",
  "联系方式": "Método de Contacto",
  "收银员管理": "Gestión de Cajeros",
  "编辑": "Editar",
  "手机号": "Número de Teléfono Móvil",
  "请输入登录账号": "Por favor ingrese la cuenta de inicio de sesión",
  "长度在6到16个字符": "Longitud entre 6 a 16 caracteres",
  "两次输入密码不一致！": "Las dos contraseña ingresadas no son consistentes!",
  "禁用": "Desactivar",
  "删除后不可恢复，确认删除该记录吗?": "No se puede recuperar después de la eliminación, confirmar la eliminación de este registro?",
  "提示": "Aviso",
  "后厨人员管理": "Gestión del Personal de Cocina",
  "添加后厨人员": "Agregar Personal de Cocina",
  "添加后厨账号": "Agregar Cuenta de Cocina",
  "普通分类": "Clasificación Común",
  "添加分类": "Agregar Categoría",
  "图片": "Imagen",
  "分类排序": "Orden de la Categoría",
  "税率设置": "Configuración de la Tasa Impositiva",
  "添加税率": "Agregar Tasa Impositiva",
  "税率分类名称": "Nombre de la Categoría de la Tasa Impositiva",
  "税率": "Tasa Impositiva",
  "适用于菜品分类": "Aplicable a la Clasificación de Platos",
  "未找到相应数据": "No se Encontraron Datos Correspondientes",
  "请输入分类名称": "Por favor ingrese el nombre de la categoría",
  "分类排序不能为空": "El Orden de la Categoría no Puede Estar Vacío",
  "分类排序必须为数字": "El Orden de la Categoría Debe Ser un Número",
  "正在翻译，请稍后": "Traduciendo, por favor espere",
  "多语言翻译": "Traducción Multilingüe",
  "修改分类": "Modificar Categoría",
  "翻译": "Traducción",
  "分类图片": "Imagen de la Categoría",
  "外卖商品": "Mercancía para Entrega a Domicilio",
  "店内商品": "Mercancía en el Local",
  "商品管理": "Gestión de Mercancías",
  "分类管理": "Gestión de Categorías",
  "上架中": "En Venta",
  "下架": "Quitar de la Venta",
  "商品名称": "Nombre de la Mercancía",
  "请输入商品名称": "Por favor ingrese el nombre de la mercancía",
  "添加产品": "Agregar Producto",
  "全部": "Todos",
  "产品": "Producto",
  "实际销量": "Ventas Reales",
  "库存": "Inventario",
  "发布时间": "Tiempo de Publicación",
  "销售价": "Precio de Venta",
  "下架中": "Fuera de Estante",
  "强制下架": "Desactivar Forzosamente",
  "重新上架": "Reactivar en Estante",
  "上架": "En Estante",
  "确认要": "Confirmar",
  "成功": "éxito",
  "删除成功": "Eliminado Exitosamente",
  "请先选择一个选项": "Por favor, Seleccione una Opción Primero",
  "正在完成翻译，请稍后操作": "Finalizando Traducción, Por Favor Espere para Operar",
  "请检查表单的必填项是否全部填写": "Por favor verifique si todos los elementos obligatorios del formulario están completos",
  "补全成功": "Completado con éxito",
  "主语言选择": "Selección de Idioma Principal",
  "请选择主语言": "Por favor seleccione el Idioma Principal",
  "高级设置": "Configuraciones Avanzadas",
  "取消": "Cancelar",
  "修改": "Modificar",
  "保存成功": "Guardado Exitosamente",
  "规格": "Especificación",
  "库存计算方式": "Método de Cálculo de Inventario",
  "下单减库存": "Reducir Inventario al Ordenar",
  "特色分类": "Categorización Destacada",
  "产品规格": "Especificación del Producto",
  "单规格": "Especificación única",
  "多规格": "Múltiples Especificaciones",
  "此商品正在参加活动，不能修改规格": "Este producto está participando en una actividad y no se puede modificar la especificación",
  "基本信息": "Información Básica",
  "AI魔法创建": "Creación Mágica AI",
  "通过人工智能技术，可以根据商品名称自动填写商品详细信息，如配料、卖点、口味等。": "Mediante tecnología de inteligencia artificial, puedes completar automáticamente la información detallada del producto según el nombre del producto, como ingredientes, puntos de venta, sabor, etc.",
  "所属分类": "Categoría de Pertenencia",
  "请选择商品分类": "Por favor seleccione la Categoría del Producto",
  "请填写商品详情": "Por favor complete los Detalles del Producto",
  "商品详情": "Detalles del Producto",
  "换一换": "Cambiar",
  "产品价格": "Precio del Producto",
  "请填写产品价格": "Por favor ingrese el Precio del Producto",
  "请填写包装费": "Por favor ingrese la Tarifa de Envoltura",
  "规格明细": "Detalles de la Especificación",
  "规格名称": "Nombre de la Especificación",
  "请输入内容": "Por favor, Ingrese el Contenido",
  "价格": "Precio",
  "添加规格": "Agregar Especificación",
  "商品图片": "Imagen del Producto",
  "请上传商品图片": "Por favor suba la Imagen del Producto",
  "从AI图库中选择": "Seleccionar desde la Biblioteca de Imágenes de AI",
  "使用中文从AI图库搜索": "Buscar desde la Biblioteca de Imágenes de AI usando Chino",
  "AI图库": "Biblioteca de Imágenes de AI",
  "确认使用": "Confirmar Uso",
  "AI未识别到您的商品图片": "AI no reconoció su imagen del producto",
  "可在搜索框": "Disponible en el Cuadro de Búsqueda",
  "更换菜品名称": "Cambiar Nombre del Plato",
  "请输入菜品名称！": "Por favor ingrese el Nombre del Plato!",
  "请在主语言界面上进行操作": "Por favor realice la operación en la Interfaz del Idioma Principal",
  "本商品正在参加活动，不能删除规格！": "Este producto está participando en una actividad y no se pueden eliminar las especificaciones!",
  "不能再删除了": "No se Puede Eliminar Más",
  "多语言": "Multilingüe",
  "商品加料": "Aditivos del Producto",
  "添加加料": "Agregar Aditivos",
  "加料名称": "Nombre del Aditivo",
  "如:杯型": "Por Ejemplo: Tipo Copa",
  "内容": "Contenido",
  "积分设置": "Configuración de Puntos",
  "是否开启积分赠送": "Abrir Regalo de Puntos?",
  "关闭": "Cerrar",
  "其他设置": "Otras Configuraciones",
  "商品状态": "Estado del Producto",
  "选择商品状态": "Seleccionar Estado del Producto",
  "初始销量": "Ventas Iniciales",
  "商品排序": "Orden del Producto",
  "限购数量": "Cantidad de Compra Limitada",
  "每个会员购买的最大数量，0为不限购": "La cantidad máxima que cada miembro puede comprar, 0 significa sin límite",
  "会员折扣设置": "Configuración de Descuento para Miembros",
  "是否开启会员折扣": "?Abrir Descuento para Miembros?",
  "默认折扣": "Descuento Predeterminado",
  "单独设置折扣": "Establecer Descuento por Separado",
  "默认折扣：默认为用户所属会员等级的折扣率": "Descuento predeterminado: el descuento es la tasa de descuento del nivel de miembro al que pertenece el usuario",
  "折扣佣金类型": "Tipo de Comisión de Descuento",
  "百分比": "Porcentaje",
  "固定金额": "Cantidad Fija",
  "会员等级": "Nivel de Miembro",
  "折扣": "Descuento",
  "请输入折扣": "Por favor, Ingrese el Descuento",
  "分销设置": "Configuración de Distribución",
  "是否开启分销": "?Abrir Distribución?",
  "分销规则": "Reglas de Distribución",
  "平台规则": "Regla de Plataforma",
  "单独规则": "Regla Individual",
  "平台规则：层级": "Regla de Plataforma: Nivel",
  "1级佣金": "Comisión de Nivel 1",
  "2级佣金": "Comisión de Nivel 2",
  "3级佣金": "Comisión de Nivel 3",
  "分销佣金类型": "Tipo de Comisión de Distribución",
  "单独分销设置": "Configuración de Distribución Individual",
  "一级佣金": "Comisión de Nivel 1",
  "二级佣金": "Comisión de Nivel 2",
  "三级佣金": "Comisión de Nivel 3",
  "请填写商品名称": "Por favor complete el Nombre del Producto",
  "你选择商品分类": "Has Seleccionado la Categoría del Producto",
  "商品卖点": "Puntos de Venta del Producto",
  "配料": "Ingredientes",
  "添加项": "Agregar Elemento",
  "删除项": "Eliminar Elemento",
  "审核状态": "Estado de Auditoría",
  "选择审核状态": "Seleccione Estado de Auditoría",
  "通过": "Aprobado",
  "未通过": "No Aprobado",
  "审核备注": "Observaciones de Auditoría",
  "请输入拒绝原因": "Por favor ingrese la Razón de Rechazo",
  "商品属性": "Atributos del Producto",
  "添加属性": "Agregar Atributos",
  "属性名称": "Nombre del Atributo",
  "属性值": "Valor del Atributo",
  "至少填写两个": "Al menos completar dos",
  "如:温度": "Por Ejemplo: Temperatura",
  "口味": "Sabor",
  "商品同步": "Sincronización del Producto",
  "同步至外卖": "Sincronizar con Servicio de Entrega",
  "库存数量": "Cantidad de Inventario",
  "请填写库存数量": "Por favor ingrese la Cantidad de Inventario",
  "请上传分类图片": "Por favor suba la Imagen de la Categoría",
  "发布": "Publicar",
  "级": "Nivel",
  "请填写口味": "Por favor, Ingrese el Sabor",
  "从AI图库搜索": "Buscar desde la Biblioteca de Imágenes de AI",
  "AI获取标签": "AI Obtiene Etiquetas",
  "标签": "Etiqueta",
  "添加的标签可以帮助AI点餐助手更准确地理解顾客的点餐需求": "Las etiquetas adicionales pueden ayudar al asistente de pedidos de IA a comprender de manera más precisa las necesidades de pedido del cliente",
  "同步至店内": "Sincronizar con Tienda Física",
  "是否同步商品至外卖": "?Sincronizar Productos con Servicio de Entrega?",
  "是否同步商品至店内": "?Sincronizar Productos con Tienda Física?",
  "付款减库存": "Pago para Reducir Inventario",
  "菜品录入使用语言": "Idioma Utilizado para el Registro de Platos",
  "网站主页": "Página de Inicio del Sitio Web",
  "主题编辑": "Edición del Tema",
  "我的菜单": "Mi Menú",
  "添加菜单": "Agregar Menú",
  "菜单名称": "Nombre del Menú",
  "图标": "ícono",
  "是否显示": "?Mostrar?",
  "更新时间": "Tiempo de Actualización",
  "正在处理": "Procesando",
  "处理失败，请重试": "Proceso Fallido, Por Favor Intente de Nuevo",
  "此操作将永久删除该记录, 是否继续?": "Esta acción eliminará permanentemente este registro, ?desea continuar?",
  "确定": "Confirmar",
  "主题选择": "Selección de Tema",
  "主题一": "Tema Uno",
  "主题二": "Tema Dos",
  "主题三": "Tema Tres",
  "主题四": "Tema Cuatro",
  "主题五": "Tema Cinco",
  "主题六": "Tema Seis",
  "主页预览": "Vista Previa de la Página de Inicio",
  "撤回": "Retirar",
  "获取预览网站失败,请检查网络或联系管理员": "Fallo al Obtener Vista Previa del Sitio Web, Por Favor Verifique la Conexión o Contacte al Administrador",
  "撤回成功": "Retirada Exitosa",
  "编辑菜单": "Editar Menú",
  "请输入广告标题": "Por favor ingrese el Título del Anuncio",
  "图标大小为": "El tamaño del ícono es",
  "显示": "Mostrar",
  "隐藏": "Ocultar",
  "请输入数字": "Por favor ingrese un Número",
  "链接": "Enlace",
  "选择链接": "Elegir Enlace",
  "提交": "Enviar",
  "请输入菜单名称": "Por favor ingrese el Nombre del Menú",
  "请选择链接地址": "Por favor seleccione la dirección del enlace",
  "链接到": "Enlazar a",
  "请上传图标": "Por favor suba el ícono",
  "确定要删除吗?": "?Está Seguro que Desea Borrar?",
  "次浏览": "Veces Visto",
  "每日必拼": "Imperdible Diario",
  "更多": "Más",
  "2人团": "Grupo de 2 Personas",
  "去开团": "Ir a Iniciar un Grupo",
  "活动砍价": "Bargaining de Actividades",
  "已抢2件": "Ya se han Comprado 2 Piezas",
  "立即砍价": "Bargain Ahora",
  "满": "Lleno",
  "可用": "Disponible",
  "立即领取": "Recibir Ahora",
  "热门直播": "Transmisión en vivo Popular",
  "已售": "Vendido",
  "限时秒杀": "Oferta por Tiempo Limitado",
  "搜索商品": "Buscar Productos",
  "线下门店": "Tienda Física",
  "门店地址": "Dirección de la Tienda",
  "您的浏览器不支持 video 标签": "Su Navegador No Admite la Etiqueta de Video",
  "店家正在直播、折扣套餐秒杀中": "El Comerciante está Transmitiendo en Vivo y ofreciendo Descuentos y Ofertas Especiales",
  "进入": "Entrar",
  "至少保留一个": "Mantener al Menos Uno",
  "咨询分类": "Categoría de Consulta",
  "全部分类": "Todas las Categorías",
  "显示数量": "Mostrar Cantidad",
  "咨询数据请到": "Los Datos de Consulta están en",
  "中管理": "Gestión en",
  "插件": "Plugin",
  "显示类型": "Tipo de Visualización",
  "有图模式": "Modo con Imágenes",
  "无图模式": "Modo sin Imágenes",
  "组件样式": "Estilo del Componente",
  "显示内容": "Mostrar Contenido",
  "拼团价格": "Precio de la Lucha en Grupo",
  "划线价格": "Precio con Línea Tachada",
  "指示点颜色": "Color del Punto Indicador",
  "重置": "Restablecer",
  "切换时间": "Cambiar Tiempo",
  "轮播图自动切换的间隔时间，单位：毫秒": "Intervalo de Tiempo para el Cambio Automático de la Imagen del Carrusel, Unidad: Milisegundos",
  "链接地址": "Dirección del Enlace",
  "添加一个": "Añadir Uno",
  "标题内容": "Contenido del Título",
  "文字内容": "Contenido del Texto",
  "链接名称": "Nombre del Enlace",
  "正在砍价": "Bargaining en Proceso",
  "商品原价": "Precio Original del Producto",
  "背景颜色": "Color de Fondo",
  "组件高度": "Altura del Componente",
  "上下边距": "Margen Superior e Inferior",
  "线条样式": "Estilo de la Línea",
  "实线": "Línea Sólida",
  "虚线": "Línea de Puntos",
  "点状": "Línea de Puntos y Rayas",
  "线条颜色": "Color de la Línea",
  "线条高度": "Altura de la Línea",
  "左右边距": "Margen Izquierdo y Derecho",
  "标题": "Título",
  "颜色": "Color",
  "每行数量": "Cantidad por Fila",
  "1个": "1 Pieza",
  "2个": "2 Piezas",
  "文字颜色": "Color del Texto",
  "公告图标": "ícono de Anuncio",
  "公告内容": "Contenido del Anuncio",
  "商品来源": "Origen del Producto",
  "自动获取": "Obtención Automática",
  "手动选择": "Selección Manual",
  "综合": "Combinado",
  "商品列表": "Lista de Productos",
  "选择产品": "Seleccionar Producto",
  "列表平铺": "Disposición de Lista",
  "横向滑动": "Deslizamiento Horizontal",
  "分列数量": "Número de Columnas",
  "单列": "Una Columna",
  "两列": "Dos Columnas",
  "三列": "Tres Columnas",
  "商品价格": "Precio del Producto",
  "商品销量": "Ventas del Producto",
  "提示文字": "Texto de Aviso",
  "搜索框样式": "Estilo de Cuadro de Búsqueda",
  "方形": "Cuadrado",
  "圆角": "Esquina Redondeada",
  "圆弧": "Arco",
  "文字对齐": "Alineación de Texto",
  "居左": "Izquierda",
  "居中": "Centro",
  "居右": "Derecha",
  "秒杀价格": "Precio de Oferta Relámpago",
  "底边距": "Margen Inferior",
  "右边距": "Margen Derecho",
  "不透明度": "Opacidad",
  "客服类型": "Tipo de Servicio al Cliente",
  "在线聊天": "Chat en Línea",
  "拨打电话": "Llamar por Teléfono",
  "电话号码": "Número de Teléfono",
  "客服图标": "Icono de Servicio al Cliente",
  "标题类型": "Tipo de Título",
  "页面名称": "Nombre de la Página",
  "页面名称仅用于后台查找": "El Nombre de la Página solo se Utiliza para la Búsqueda en el Backend",
  "分享标题": "Título de Compartir",
  "小程序端转发时显示的标题": "Título Mostrado al Reenviar en la Aplicación Mini Programa",
  "文章分类": "Categoría de Artículo",
  "文章数据请到": "Por favor ve a los Datos de Artículos en",
  "内容管理": "Gestión de Contenido",
  "文章列表": "Lista de Artículos",
  "单行": "Línea única",
  "两行": "Dos Líneas",
  "门店列表": "Lista de Tiendas",
  "选择门店": "Seleccionar Tienda",
  "展示数量": "Cantidad a Mostrar",
  "视频高度": "Altura del Video",
  "滑块可用左右方向键精确调整": "El Slider se Puede Ajustar con Precisión con las Teclas de Flecha Izquierda y Derecha",
  "视频封面": "Portada del Video",
  "视频地址": "Dirección del Video",
  "自动播放": "Reproducción Automática",
  "布局方式": "Método de Diseño",
  "堆积两列": "Apilar Dos Columnas",
  "堆积三列": "Apilar Tres Columnas",
  "堆积四列": "Apilar Cuatro Columnas",
  "橱窗样式": "Estilo de Escaparate",
  "橱窗样式最多显示四张图片，超出隐藏": "El Estilo de Escaparate Muestra hasta Cuatro Imágenes, Se Ocultan si se Exceden",
  "请确保所有图片的尺寸/比例相同": "Por favor Asegúrate de que Todas las Imágenes tengan el Mismo Tamaño/Proporción",
  "标题文字": "Texto del Título",
  "组件库": "Biblioteca de Componentes",
  "媒体组件": "Componente de Medios",
  "商城组件": "Componente de Centro Comercial",
  "工具组件": "Componente de Herramientas",
  "登录组件": "Componente de Inicio de Sesión",
  "资讯管理": "Gestión de Información",
  "添加资讯": "Agregar Información",
  "资讯ID": "ID de Información",
  "封面": "Portada",
  "资讯标题": "Título de la Información",
  "资讯分类": "Categoría de Información",
  "虚拟阅读量": "Número de Lecturas Virtual",
  "实际阅读量": "Número de Lecturas Real",
  "资讯排序": "Orden de Información",
  "已取消删除": "Eliminación Cancelada",
  "请输入文章标题": "Por favor Ingresa el Título del Artículo",
  "描述": "Descripción",
  "请输入文章描述": "Por favor Ingresa la Descripción del Artículo",
  "缩略图": "Miniatura",
  "资讯状态": "Estado de Información",
  "资讯内容": "Contenido de Información",
  "分类ID": "ID de Categoría",
  "编辑分类": "Editar Categoría",
  "恭喜你，修改成功": "Felicidades, Modificación Exitosa",
  "编辑资讯": "Editar Información",
  "份": "Porción",
  "中文": "Chino",
  "英语": "Inglés",
  "意大利语": "Italiano",
  "德语": "Alemán",
  "西班牙语": "Español",
  "法语": "Francés",
  "克罗地亚": "Croata",
  "斯洛文尼亚": "Esloveno",
  "匈牙利语": "Húngaro",
  "规格库": "Biblioteca de Especificaciones",
  "属性库": "Biblioteca de Atributos",
  "加料库": "Biblioteca de Ingredientes Adicionales",
  "规格名": "Nombre de la Especificación",
  "批量删除": "Eliminación en Lote",
  "请输入规格名称": "Por favor Ingresa el Nombre de la Especificación",
  "删除后不可恢复，确认删除吗?": "?No se puede recuperar después de la eliminación, confirmar la eliminación?",
  "属性名": "Nombre del Atributo",
  "请输入属性名称": "Por favor Ingresa el Nombre del Atributo",
  "请输入属性值": "Por favor Ingresa el Valor del Atributo",
  "添加属性名": "Añadir Nombre de Atributo",
  // =========== 建店必做 end ==================

  // ================ 订单 start ================
  "实时概况": "Visión General en Tiempo Real",
  "营业总额": "Ingresos Totales del Negocio",
  "有效订单": "órdenes Válidas",
  "退款金额": "Cantidad de Reembolso",
  "销量排行榜": "Ranking de Ventas",
  "销售额排行榜": "Ranking de Monto de Ventas",
  "订单号": "Número de Orden",
  "请输入订单号": "Por favor ingrese el número de orden",
  "配送方式": "Método de Entrega",
  "起始时间": "Hora de Inicio",
  "开始日期": "Fecha de Inicio",
  "结束日期": "Fecha de Fin",
  "导出": "Exportar",
  "全部订单": "Todas las órdenes",
  "未付款": "No Pagado",
  "进行中": "En Progreso",
  "已取消": "Cancelado",
  "已完成": "Completado",
  "订单信息": "Información de la Orden",
  "下单时间": "Hora de la Orden",
  "取消申请中": "Solicitud de Cancelación en Progreso",
  "实付款": "Pago Realizado",
  "含服务费": "Incluyendo Tarifa de Servicio",
  "含包装费": "Incluyendo Tarifa de Empaque",
  "买家": "Comprador",
  "出餐状态": "Estado del Plato",
  "准备中": "Preparando",
  "出餐中": "Cocinando",
  "待取餐": "Esperando por Recoger",
  "交易状态": "Estado de la Transacción",
  "支付方式": "Método de Pago",
  "订单详情": "Detalles de la Orden",
  "出餐": "Servir Plato",
  "退款": "Reembolso",
  "核销": "Verificar",
  "确定要出餐吗?": "?Está seguro de que desea servir el plato?",
  "确定要核销吗?": "?Está seguro de que desea verificar?",
  "恭喜你，操作成功": "Felicidades, Operación Exitosa",
  "已取消核销": "Verificación Cancelada",
  "订单来源": "Origen de la Orden",
  "用户": "Usuario",
  "订单金额": "Monto de la Orden",
  "配送费": "Tarifa de Entrega",
  "服务费": "Tarifa de Servicio",
  "优惠券抵扣": "Deducción de Cupón",
  "积分抵扣": "Deducción de Puntos",
  "满减金额": "Monto de Descuento por Compra",
  "优惠金额": "Monto de Descuento",
  "实付款金额": "Monto de Pago Real",
  "用餐方式": "Modo de Comida",
  "取餐时间": "Hora de Recogida",
  "桌号": "Número de Mesa",
  "修改价格": "Modificar Precio",
  "门店信息": "Información de la Tienda",
  "商品信息": "Información del Producto",
  "会员折扣价": "Precio de Descuento para Miembros",
  "购买数量": "Cantidad de Compra",
  "商品总价": "Precio Total de Productos",
  "收货信息": "Información de Recepción",
  "收货人": "Destinatario",
  "收货电话": "Teléfono del Destinatario",
  "收货地址": "Dirección de Entrega",
  "备注": "Observación",
  "自提用户信息": "Información de Recogida por el Cliente",
  "用户信息": "Información del Usuario",
  "联系手机": "Contacto Móvil",
  "付款信息": "Información de Pago",
  "应付款金额": "Monto Total a Pagar",
  "支付流水号": "Número de Transacción de Pago",
  "付款状态": "Estado de Pago",
  "付款时间": "Hora de Pago",
  "发货信息": "Información de Envío",
  "发货状态": "Estado de Envío",
  "取消信息": "Información de Cancelación",
  "商家备注": "Observación del Vendedor",
  "门店自提核销": "Confirmación de Recogida en Tienda",
  "核销员": "Revisor",
  "核销状态": "Estado de Confirmación",
  "已核销": "Confirmado",
  "核销时间": "Hora de Confirmación",
  "返回上一页": "Volver a la Página Anterior",
  "确认发货": "Confirmar Envío",
  "确认审核": "Confirmar Revisión",
  "请选择物流公司": "Por favor Seleccione una Compañía de Logística",
  "请填写物流单号": "Por favor Ingrese el Número de Guía de Envío",
  "恭喜你，发货成功": "?Felicidades, Envío Exitoso!",
  "恭喜你，审核成功": "?Felicidades, Revisión Exitosa!",
  "订单价格修改": "Modificación de Precio de la Orden",
  "运费金额": "Monto de Flete",
  "最终付款价": "Precio Final de Pago",
  "取消订单": "Cancelar Orden",
  "请输入备注": "Por favor Ingrese una Observación",
  "请输入退款金额": "Por favor Ingrese la Cantidad de Reembolso",
  "确认退款?": "?Confirmar Reembolso?",
  "已取消退款": "Reembolso Cancelado",
  "含配送费": "Incluyendo Tarifa de Envío",
  "确认送达": "Confirmar Entrega",
  "是否确认此操作?": "?Confirma Esta Operación?",
  "配送状态": "Estado de Entrega",
  "备注信息": "Información de Observación",
  "期望配送时间": "Tiempo de Entrega Esperado",
  "订单状态": "Estado de la Orden",
  "骑手姓名": "Nombre del Repartidor",
  "骑手电话": "Teléfono del Repartidor",
  "操作时间": "Tiempo de Operación",
  "详情": "Detalles",
  "此操作将确认送达, 是否继续?": "Esta Operación Confirmará la Entrega, ?Desea Continuar?",
  "配送时间": "Tiempo de Entrega",
  "配送信息": "Información de Entrega",
  "配送类型": "Tipo de Entrega",
  "配送距离": "Distancia de Entrega",
  "配送员": "Repartidor",
  "配送电话": "Teléfono de Entrega",
  "配送费用": "Tarifa de Entrega",
  "送达时间": "Hora de Llegada",
  "取消原因": "Motivo de Cancelación",
  "请输入取消原因": "Por favor Ingrese el Motivo de Cancelación",
  "米": "Metro",
  // ================ 订单 end  ================

  // ================= 门店 start ==============
  "门店ID": "Identificación de la Tienda",
  "联系地址": "Dirección de Contacto",
  "下载二维码": "Descargar Código QR",
  "H5网页": "Página Web H5",
  "添加门店": "Incorporar Establecimiento",
  "设置": "Configuración",
  "恭喜你，门店删除成功": "Felicidades, Eliminación Exitosa de la Tienda",
  "请输入地点": "Por favor, Ingrese la Ubicación",
  "添加": "Incorporar",
  "等级": "Grado",
  "请选择会员等级": "Por favor Seleccione el Grado de Membresía",
  "性别": "Género",
  "请选择性别": "Por favor Seleccione Género",
  "微信昵称": "Apodo de WeChat",
  "请输入微信昵称": "Por favor Ingrese el Apodo de WeChat",
  "微信头像": "Foto de Perfil de WeChat",
  "昵称": "Apodo",
  "用户余额": "Saldo del Usuario",
  "累积消费金额": "Monto de Consumo Acumulado",
  "注册时间": "Tiempo de Registro",
  "分钟后自动清理桌台": "Limpiar Automáticamente las Mesas Después de Minutos",
  "扫桌码点餐和收银桌台点餐定时清台时间": "Tiempo Programado para Limpiar las Mesas Después de Escanear Códigos de Mesa para Pedidos y Mesas de Caja",
  "到店自提": "Recoger en Tienda",
  "打包带走": "Para Llevar",
  "店内就餐": "Para Comer en el Local",
  "外卖配送至少选择一种！": "?Seleccione al Menos un Método de Entrega para Llevar!",
  "店内配置至少选择一种！": "?Seleccione al Menos una Configuración en el Local!",
  "恭喜你，设置成功": "?Felicidades, Configuración Exitosa!",
  "恭喜你，门店修改成功": "?Felicidades, Modificación de la Tienda Exitosa!",
  "门店": "Tienda",
  "提现金额": "Monto de Retiro",
  "打款方式": "Método de Pago",
  "待审核": "Pendiente de Revisión",
  "审核通过": "Aprobado",
  "驳回": "Rechazado",
  "原因": "Motivo",
  "已打款": "Pago Realizado",
  "审核": "Revisión",
  "确认打款": "Confirmar Pago",
  "确认要打款吗?": "?Confirmar Pago?",
  "供应商名称": "Nombre del Proveedor",
  "余额变动场景": "Escenario de Cambio de Saldo",
  "收入": "Ingreso",
  "提现": "Retiro",
  "起始日期": "Fecha de Inicio",
  "变动金额": "Monto Cambiado",
  "描述/说明": "Descripción/Explicación",
  "创建时间": "Tiempo de Creación",
  "恭喜你，门店添加成功": "?Felicidades, Adición de Tienda Exitosa!",
  "驳回原因": "Motivo de Rechazo",
  "提现审核": "Revisión de Retiro",
  "小票打印设置": "Configuración de Impresión de Recibos",
  "是否开启商户小票打印": "Activar Impresión de Recibos del Comerciante",
  "选择打印机": "Seleccionar Impresora",
  "是否开启顾客小票打印": "Activar Impresión de Recibos para Clientes",
  "选择打印机二": "Seleccionar Impresora Dos",
  "是否开启厨房小票打印": "Activar Impresión de Recibos de Cocina",
  "选择打印机三": "Seleccionar Impresora Tres",
  "恭喜你，打印设置成功": "?Felicidades, Configuración de Impresión Exitosa!",
  "小票打印机列表": "Lista de Impresoras de Recibos",
  "打印机ID": "ID de la Impresora",
  "打印机名称": "Nombre de la Impresora",
  "编辑小票打印机": "Editar Impresora de Recibos",
  "打印机类型": "Tipo de Impresora",
  "米泰打印机": "Impresora Mettai",
  "打印机编号": "Número de Serie de la Impresora",
  "打印机编号为9位数字，查看米泰打印机底部贴纸上面的编号": "El número de serie de la impresora consta de 9 dígitos. Verifique el número en la etiqueta sobre la base de la impresora Mettai",
  "打印机秘钥": "Clave de la Impresora",
  "打印联数": "Copias de Impresión",
  "同一订单，打印的次数": "Número de Impresiones para la Misma Orden",
  "数字越小越靠前": "A menor número, mayor prioridad",
  "新增小票打印机": "Agregar Nueva Impresora de Recibos",
  "恭喜你，添加成功": "?Felicidades, Adición Exitosa!",
  "配送方式设置": "Configuración de Método de Entrega",
  "商家配送": "Entrega por el Comerciante",
  "自动配送时间(分钟)": "Tiempo de Entrega Automática (minutos)",
  "设置0不自动配送，下单后未配送，设置时间后自动操作配送": "Configurar en 0 impide la entrega automática. Después de realizar un pedido sin entrega, la entrega automática se iniciará después del tiempo establecido",
  "商户编号": "ID del Comerciante",
  "门店编号": "ID de la Tienda",
  "环境": "Ambiente",
  "测试环境": "Ambiente de Pruebas",
  "正式环境": "Ambiente de Producción",
  "回调地址": "Dirección de Devolución de Llamada",
  "运营城市": "Ciudad Operativa",
  "恭喜你，上传设置成功": "?Felicidades, Configuración de Subida Exitosa!",
  "菜品打印列表": "Lista de Impresión de Comidas",
  "名称": "Nombre",
  "打印类型": "Tipo de Impresión",
  "外卖": "Entrega a Domicilio",
  "店内": "Consumo en el Local",
  "菜品打印": "Impresión de Comidas",
  "是否开启": "Activar",
  "配送打印": "Impresión de Entrega",
  "店内打印": "Impresión del Local",
  "打印方式": "Método de Impresión",
  "付款打印": "Impresión de Pago",
  "下单打印": "Impresión de Pedido",
  "商品分组": "Agrupación de Productos",
  "男": "Masculino",
  "女": "Femenino",
  "未知": "Desconocido",
  "文件管理": "Gestión de Archivos",
  "移动至": "Mover a",
  "点击上传": "Hacer clic para Subir",
  "删除失败": "Eliminación Fallida",
  "请选择文件": "Por favor Seleccione un Archivo",
  "确定移动选中的文件吗？, 是否继续?": "?Está seguro de querer mover los archivos seleccionados? ?Desea continuar?",
  "只能上传图片！": "?Solo se pueden subir imágenes!",
  "上传文件只能是图片格式!": "?El archivo subido debe ser de formato de imagen!",
  "上传文件大小不能超过 2MB!": "?El tamaño del archivo subido no puede superar los 2 MB!",
  "请查看/裁切其它上传图片!": "?Por favor, vea/recorte otras imágenes subidas!",
  "图片上传中,请等待": "Subiendo Imagen, por favor espere",
  "当前图片上传失败!": "?Falló la subida de la imagen actual!",
  "本次上传图片失败": "Falló la subida de imagen en esta ocasión",
  "本次最多只能上传1个文件": "Solo se puede subir 1 archivo a la vez",
  "裁剪图片": "Recortar Imagen",
  "选择优惠券": "Seleccionar Cupón",
  "数量": "Cantidad",
  "无限制": "Sin Límite",
  "请输入等级名称": "Por favor Ingrese el Nombre del Grado",
  "长度在3到5个字符": "La longitud debe ser de 3 a 5 caracteres",
  "错了哦，这是一条错误消息": "Oops, este es un mensaje de error",
  "增加税率": "Agregar Tasa de Impuesto",
  "税率分类": "Categoría de Tasa de Impuesto",
  "请输入税率分类": "Por favor Ingrese la Categoría de Tasa de Impuesto",
  "自定义税率分类": "Categoría de Tasa de Impuesto Personalizada",
  "请输入税率值": "Por favor Ingrese el Valor de la Tasa de Impuesto",
  "单位是": "La unidad es",
  "适用菜品分类": "Categoría de Comida Aplicable",
  "请选择菜品分类": "Por favor Seleccione la Categoría de Comida",
  "修改税率信息": "Modificar Información de la Tasa de Impuesto",
  "分类名称不能为空": "El Nombre de la Categoría no puede estar vacío",
  // ================= 门店 end ==============
  // =====================  营销工具start ==========
  "会员管理": "Gestión de Membresía",
  "等级管理": "Gestión de Niveles",
  "余额明细": "Detalles de Saldo",
  "请输入昵称": "Por favor Ingresa Apodo",
  "邮箱": "Correo Electrónico",
  "请输入邮箱地址": "Por favor Ingresa la Dirección de Correo Electrónico",
  "无等级": "Sin Nivel",
  "余额": "Saldo",
  "积分": "Puntos",
  "生日": "Cumpleaños",
  "充值": "Recarga",
  "恭喜你，用户删除成功": "Felicidades, Eliminación Exitosa de Usuario",
  "请选择等级": "Por favor Seleccione un Nivel",
  "管理员备注": "Observaciones del Administrador",
  "请输入管理员备注": "Por favor Ingrese Observaciones del Administrador",
  "恭喜你，用户修改成功": "Felicidades, Modificación de Usuario Exitosa",
  "会员充值": "Recarga de Membresía",
  "充值余额": "Monto de Recarga",
  "当前余额": "Saldo Actual",
  "充值方式": "Método de Recarga",
  "增加": "Aumentar",
  "减少": "Disminuir",
  "最终金额": "Monto Final",
  "变更金额": "Monto Modificado",
  "请输入变更金额": "Por favor Ingrese el Monto Modificado",
  "添加等级": "Agregar Nivel",
  "等级名称": "Nombre del Nivel",
  "权重": "Peso",
  "升级条件": "Condiciones de Ascenso",
  "等级权重": "Peso del Nivel",
  "请输入等级权重": "Por favor Ingrese el Peso del Nivel",
  "权重越大，等级越高": "A mayor peso, mayor nivel",
  "等级折扣": "Descuento de Nivel",
  "请输入等级折扣": "Por favor Ingrese el Descuento de Nivel",
  "满足以下勾选的其中一个条件，会员自动升级到该等级": "Al cumplir una de las condiciones marcadas abajo, el miembro se actualizará automáticamente a ese nivel",
  "累计消费满": "Consumo Acumulado Alcanza",
  "编辑等级": "Editar Nivel",
  "累计积分满": "Puntos Acumulados Alcanzados",
  "推荐人数满": "Número de Recomendaciones Alcanzado",
  "恭喜你，等级修改成功": "Felicidades, nivel modificado exitosamente",
  "个": "piezas",
  "充值设置": "Configuración de Recarga",
  "是否开启余额充值": "Habilitar recarga de saldo",
  "注：如开启则移动端显示充值按钮，如果小程序没有资质审核不过可不开启": "Nota: Si se habilita, el botón de recarga se mostrará en el extremo móvil; si el mini-programa no supera la revisión de calificación, se puede mantener deshabilitado",
  "是否开启自定义金额": "Habilitar cantidad personalizada",
  "注：如开启则用户可以填写充值金额": "Nota: Si se habilita, los usuarios pueden ingresar una cantidad personalizada de recarga",
  "最低充值金额": "Cantidad mínima de recarga",
  "注：自定义充值金额最低充值多少€": "Nota: ?Cuál es el monto mínimo de recarga para las cantidades personalizadas de recarga?",
  "充值说明": "Instrucciones de Recarga",
  "充值套餐": "Paquetes de Recarga",
  "支付金额": "Monto de Pago",
  "到账数量": "Cantidad Recibida",
  "充值时间": "Hora de Recarga",
  "到账金额": "Monto Recibido",
  "赠送金额": "Monto Regalado",
  "提现设置": "Configuración de Retiro",
  "是否开启提现": "Habilitar retiros",
  "注：如开启则移动端显示余额提现": "Nota: Si se habilita, el extremo móvil mostrará la opción de retirar saldo",
  "提现比例": "Porcentaje de Retiro",
  "注：提现比例请填写数字0~100": "Nota: Por favor, ingrese un porcentaje de retiro entre 0 y 100",
  "例：提现金额(100.00元) * 提现比例(100%) = 实际到账(100€)": "Ejemplo: Monto de Retiro ($100) * Porcentaje de Retiro (100%) = Monto Recibido Real (€100)",
  "最低提现金额": "Monto Mínimo de Retiro",
  "注：最低提现金额多少元": "Nota: ?Cuál es el monto mínimo de retiro en yuanes?",
  "请选择状态": "Por favor seleccione el estado",
  "提现方式": "Método de Retiro",
  "请选择提现方式": "Por favor seleccione un método de retiro",
  "微信": "WeChat",
  "支付宝": "Alipay",
  "银行卡": "Tarjeta Bancaria",
  "请输入用户ID": "Por favor ingrese el ID de usuario",
  "请输入昵称/姓名/手机号": "Por favor ingrese apodo/nombre/número de teléfono",
  "提现信息": "Información de Retiro",
  "支付宝名称": "Nombre de Alipay",
  "支付宝账号": "Cuenta de Alipay",
  "银行名称": "Nombre del Banco",
  "开户名": "Nombre de la Cuenta",
  "银行卡号": "Número de Tarjeta Bancaria",
  "申请时间": "Hora de Solicitud",
  "审核时间": "Hora de Revisión",
  "微信付款": "Pago de WeChat",
  "该操作将使用微信支付企业付款到零钱功能，确定打款吗？": "Esta operación utilizará la función de pago empresarial de WeChat para transferir al monedero. ?Está seguro de que desea proceder?",
  "添加充值套餐": "Agregar Paquete de Recarga",
  "套餐名称": "Nombre del Paquete",
  "请输入套餐名称": "Por favor ingrese el nombre del paquete",
  "请输入支付金额": "Por favor introduzca el monto del pago",
  "请输入赠送金额": "Proporcione el monto del regalo",
  "请输入到账金额": "Por favor especifique el monto acreditado",
  "请输入排序": "Por favor ingrese el orden de clasificación",
  "用户ID": "Identificación de Usuario",
  "会员卡管理": "Administración de Tarjetas de Miembro",
  "领取记录": "Registros de Recepción",
  "删除记录": "Borrar Registro",
  "请输入关键词": "Por favor ingrese la palabra clave",
  "过期": "Caducado",
  "有效": "Válido",
  "客户信息": "Datos del Cliente",
  "会员卡名称": "Nombre de la Tarjeta de Miembro",
  "有效期": "Período de Validez",
  "折": "Descuento",
  "领取时间": "Hora de Recepción",
  "延期": "Prorrogar",
  "撤销": "Revocar",
  "添加会员卡": "Agregar Tarjeta de Miembro",
  "启用": "Activar",
  "月": "Mes",
  "永久有效": "Válido de Forma Permanente",
  "领取数量": "Número de Receptores",
  "发卡": "Emitir Tarjeta",
  "领取设置": "Configuraciones de Recepción",
  "请检查必填项是否填写完整": "Por favor revise si los campos obligatorios están completamente completados",
  "领取人数": "Número de Destinatarios",
  "删除时间": "Hora de Eliminación",
  "请填写有效期": "Por favor rellene el período de validez",
  "有效期限（月），0为永久有效": "Período de validez (en meses), 0 para validez indefinida",
  "请填写价格": "Por favor proporcione el precio",
  "用户购买会员卡需要支付的金额，0为用户免费领取": "La cantidad que los usuarios deben pagar para comprar la tarjeta de membresía, 0 para emisión gratuita",
  "使用须知": "Instrucciones de Uso",
  "请填写使用须知": "Por favor proporcione instrucciones de uso",
  "请填写会员卡名称": "Por favor complete el nombre de la tarjeta de membresía",
  "卡片类型": "Tipo de Tarjeta",
  "卡片样式": "Estilo de Tarjeta",
  "请填写排序": "Por favor ingrese el orden de clasificación",
  "会员权益": "Beneficios de Membresía",
  "无折扣": "Sin Descuento",
  "请填写折扣": "Por favor complete el descuento",
  "开卡赠送": "Regalo al Activar la Tarjeta",
  "优惠券": "Cupón",
  "请填写积分数量": "Por favor proporcione la cantidad de puntos",
  "请填写余额数量": "Proporcione la cantidad de saldo",
  "请填写优惠券": "Por favor complete el cupón",
  "添加优惠券": "Agregar Cupón",
  "券名称": "Nombre del Cupón",
  "每人领取数量": "Cantidad por Persona",
  "选择优惠券弹出层": "Selección de Ventana Emergente de Cupón",
  "您已经选择了十五张优惠券，若要更换请删除其他优惠券！": "?Ya has seleccionado quince cupones, por favor elimina otros si deseas reemplazarlos!",
  "产品编码": "Código de Producto",
  "请填写产品编码": "Por favor complete el código de producto",
  "产品划线价": "Precio de Lista del Producto",
  "请填写产品划线价": "Por favor proporcione el precio de lista del producto",
  "商品重量": "Peso del Producto",
  "请填写商品重量": "Por favor proporcione el peso del producto",
  "批量设置": "Configuración en Lote",
  "划线价": "Precio de Lista",
  "重量": "Peso",
  "应用": "Aplicar",
  "规格图片": "Imagen de Especificación",
  "规格值": "Valor de Especificación",
  "请输入规格值": "Por favor ingrese el valor de especificación",
  "请填写规则名或规则值": "Por favor ingrese el nombre de regla o el valor de regla",
  "规格值不能为空": "El valor de especificación no puede estar vacío",
  "卡名称": "Nombre de Tarjeta",
  "卡ID": "Identificación de Tarjeta",
  "无": "Ninguno",
  "选择会员": "Seleccionar Miembro",
  "恭喜你，发卡成功": "Felicidades, emisión de tarjeta exitosa",
  "副卡数": "Número de Tarjetas Suplementarias",
  "张": "piezas",
  "选择日期": "Seleccionar Fecha",
  "签到设置": "Configuración de Firma",
  "签到记录": "Registros de Firma",
  "是否开启签到有礼": "Habilitar Regalos por Firma",
  "每日签到固定奖励": "Recompensa Fija por Firma Diaria",
  "每日签到送": "Regalo por Firma Diaria",
  "递增奖励": "Recompensa Incremental",
  "有": "Sí",
  "第二天起递增奖励": "Recompensa Incremental a partir del Segundo Día",
  "请输入第二天起递增积分数": "Por favor ingrese los puntos incrementales a partir del segundo día",
  "第": "Día",
  "请输入第几天不再递增": "Ingrese el día en que deja de incrementarse",
  "天起不再递增": "No más incremento a partir de este día en adelante",
  "连续签到额外奖励 （达到额外奖励最大天数时，继续签到不会再获得额外奖励，断签后重新开始计算）": "Recompensas Adicionales por Firma Continua (Al alcanzar los días máximos de recompensa adicional, las firmas posteriores no recibirán recompensas adicionales; el conteo se reinicia después de una firma ausente)",
  "额外奖励": "Recompensa Adicional",
  "连续签到": "Firma Consecutiva",
  "请输入连续签到天数": "Por favor ingrese el número de días de firma consecutiva",
  "积分奖励": "Recompensas de Puntos",
  "送": "regalar",
  "请输入连续签到天数的积分": "Por favor proporcione puntos para los días de firma consecutiva",
  "规则": "Reglas",
  "规则说明": "Explicación de las Reglas",
  "请添加至少一项额外奖励！": "?Por favor a?ada al menos una recompensa adicional!",
  "天数不能为空！": "?Los días no pueden estar vacíos!",
  "请输入连续签到积分数！": "?Por favor ingrese los puntos para las firmas consecutivas!",
  "每日签到送积分有误": "Error en la recompensa de puntos por firma diaria",
  "恭喜你，保存成功": "?Felicidades, guardado exitoso!",
  "连续签到天数": "Días de Firma Consecutiva",
  "不限": "Ilimitado",
  "签到时间": "Hora de Firma",
  "时间": "Tiempo",
  "请输入用户昵称": "Por favor ingrese el apodo del usuario",
  "签到日期": "Fecha de Firma",
  "活动奖品": "Premios de Actividad",
  "取号记录": "Registros de Reservas de Números",
  "桌号管理": "Gestión de Mesas",
  "取号设置": "Configuración de Reserva de Números",
  "请输入手机号": "Por favor ingrese el número de teléfono",
  "待叫号": "Por Llamar",
  "已入座": "Sentado",
  "已过号": "Perdido",
  "就餐号": "Número de Comida",
  "就餐人数": "Cantidad de Comensales",
  "桌位名称": "Nombre de la Mesa",
  "取号时间": "Hora de Reserva de Número",
  "待取号": "Por Reservar",
  "是否开启打印": "Habilitar Impresión",
  "须知": "Instrucciones",
  "请输入须知": "Por favor ingrese las instrucciones",
  "商家说明": "Descripción del Comercio",
  "请输入商家说明": "Por favor proporcione la descripción del comercio",
  "取号规则": "Reglas de Reserva de Números",
  "等待时间": "Tiempo de Espera",
  "人数最小值": "Número Mínimo de Personas",
  "人数最大值": "Número Máximo de Personas",
  "等待时间(分钟)": "Tiempo de Espera (minutos)",
  "请输入桌位名称": "Por favor ingrese el nombre de la mesa",
  "请输入人数最小值": "Por favor introduzca el número mínimo de personas",
  "请输入人数最大值": "Por favor introduzca el número máximo de personas",
  "请输入等待时间": "Por favor ingrese el tiempo de espera",
  "商品设置": "Configuraciones de Productos",
  "兑换记录": "Registros de Canje",
  "活动名称": "Nombre de la Actividad",
  "请输入活动名称": "Por favor ingrese el nombre de la actividad",
  "活动列表": "Lista de Actividades",
  "添加活动": "Agregar Actividad",
  "活动价格": "Precio de la Actividad",
  "发放数量": "Cantidad Distribuida",
  "参与人数": "Número de Participantes",
  "终止": "Terminar",
  "购买记录": "Registros de Compra",
  "新增活动会场": "Agregar Nuevo Espacio de Actividad",
  "活动标题": "Título de la Actividad",
  "请输入活动标题": "Por favor, introduce el título de la actividad",
  "活动日期": "Fecha de la Actividad",
  "礼包设置": "Configuración del Paquete de Regalo",
  "优惠券id": "ID del Cupón",
  "购买设置": "Configuraciones de Compra",
  "购买金额": "Monto de Compra",
  "会员购买等级": "Nivel de Compra para Miembros",
  "指定等级": "Nivel Designado",
  "购买次数": "Frecuencia de Compra",
  "限购": "Límite de Compra",
  "每人限购": "Límite de Compra por Persona",
  "次": "Veces",
  "发放设置": "Configuración de Distribución",
  "请输入发放数量": "Por favor, introduce la cantidad a distribuir",
  "返回": "Volver",
  "请勿重复添加": "Por favor, evita agregar duplicados",
  "至少选择一个优惠券": "Por favor, selecciona al menos un cupón",
  "新增活动": "Agregar Nueva Actividad",
  "券包设置": "Configuraciones del Paquete de Cupones",
  "下载推广码": "Descargar Código Promocional",
  "下载类型": "Tipo de Descarga",
  "使用该功能前，需前往小程序后台，在“设置”-“接口设置”-“公众号关注组件”中设置要展示的公众号。注：设置的公众号需与小程序主体一致": "Antes de usar esta función, accede al backend del mini-programa y en 'Configuraciones'-'Configuraciones de Interfaces'-'Seguir Cuenta Pública,' establece la cuenta pública a mostrar. Nota: La cuenta pública configurada debe coincidir con la entidad del mini-programa",
  "去配置": "Ir a Configuración",
  "若没有配置公众号，功能将不生效": "Si no se configura ninguna cuenta pública, la función no surtirá efecto",
  "在一个小程序的生命周期内，只有从以下场景进入小程序，才具有展示引导关注公众号的能力": "Solo al entrar al mini-programa desde los siguientes escenarios durante su ciclo de vida, se activará la habilidad de mostrar y guiar para seguir la cuenta pública",
  "当小程序从扫小程序码打开时": "Cuando el mini-programa se abre escaneando el código del mini-programa",
  "当从其他小程序返回小程序时，若小程序之前未被销毁，则该组件保持上一次打开小程序时的状态": "Cuando se regresa al mini-programa desde otro mini-programa, si el mini-programa previo no se destruyó, el componente mantendrá el estado de la última vez que se abrió el mini-programa",
  "公众号关注": "Suscripción a Cuenta Pública",
  "新客设置": "Configuración de Nuevo Cliente",
  "是否开启活动": "?Está habilitada la actividad?",
  "活动时间": "Período de Actividad",
  "背景图": "Imagen de Fondo",
  "赠送优惠券": "Regalar Cupón",
  "请选择优惠券": "Por favor, selecciona un cupón",
  "赠送积分": "Regalar Puntos",
  "请输入赠送积分": "Por favor, introduce los puntos a regalar",
  "直播同步": "Sincronización de Transmisión en Vivo",
  "同步直播": "Sincronizar Transmisión en Vivo",
  "请输入直播间名称/主播昵称": "Por favor, introduce el nombre de la sala de transmisión en vivo/apodo del anfitrión",
  "直播间ID": "ID de la Sala de Transmisión en Vivo",
  "直播间名称": "Nombre de la Sala de Transmisión en Vivo",
  "主播昵称": "Apodo del Anfitrión",
  "直播开始时间": "Hora de Inicio de la Transmisión en Vivo",
  "直播结束时间": "Hora de Fin de la Transmisión en Vivo",
  "直播间状态": "Estado de la Sala de Transmisión en Vivo",
  "置顶": "Fijar en la Parte Superior",
  "未置顶": "No Fijado",
  "已置顶": "Fijado",
  "设为置顶": "Establecer como Principal",
  "取消置顶": "Quitar de la Parte Superior",
  "直播中": "En Vivo",
  "未开始": "No Iniciado",
  "已结束": "Terminado",
  "禁播": "Prohibir Transmisión en Vivo",
  "暂停": "Pausar",
  "异常": "Anormal",
  "已过期": "Caducado",
  "置顶成功": "Fijado Exitosamente",
  "邀请活动": "Evento de Invitación",
  "个人中心图片": "Imagen del Centro Personal",
  "请输入用户昵称/手机号": "Por favor, introduce el apodo/número de teléfono del usuario",
  "邀请人": "Persona que Invita",
  "被邀请人": "Persona Invitada",
  "参加时间": "Hora de Participación",
  "个人中心显示": "Visualización del Centro Personal",
  "参与记录": "Registros de Participación",
  "礼品记录": "Registros de Regalos",
  "推广二维码": "Código QR de Promoción",
  "编辑活动会场": "Editar Recinto del Evento",
  "请输入分享标题": "Por favor, introduce el título de compartir",
  "请输入分享内容": "Por favor, introduce el contenido a compartir",
  "分享内容": "Contenido Compartido",
  "分享图": "Imagen de Compartir",
  "个人中心状态": "Estado del Centro Personal",
  "邀请成功的条件": "Condiciones para una Invitación Exitosa",
  "邀请成为会员": "Invitar a ser Miembro",
  "邀请成为会员且消费": "Invitar a ser Miembro y Consumir",
  "礼品设置": "Configuraciones de Regalos",
  "奖项": "Premio",
  "每邀请": "Por Invitación",
  "人获得礼品": "Persona Recibe un Regalo",
  "添加奖励项": "Agregar ítem de Recompensa",
  "请上传背景图": "Por favor, sube la imagen de fondo",
  "请上传分享图": "Por favor, sube la imagen de compartir",
  "请添加奖项": "Por favor, a?ade un premio",
  "开启首页推送": "Habilitar Notificaciones en la Página de Inicio",
  "建议换活动，此名称更换，商城首页弹窗根据此名称不同来弹窗": "Se recomienda cambiar la actividad; el cambio de este nombre ajustará la ventana emergente en la página de inicio del centro comercial según el nombre",
  "类型": "Tipo",
  "图文": "Texto e Imagen",
  "纯图": "Solo Imagen",
  "领取优惠券": "Recibir Cupón",
  "请输入标题": "Por favor, introduce un título",
  "弹窗图片": "Imagen Emergente",
  "图片为2M以内大小，格式限png，jpg格式": "El tamaño de la imagen debe ser de hasta 2MB, con formato PNG o JPG",
  "建议尺寸": "Tamaño Sugerido",
  "按钮文案": "Texto del Botón",
  "简介说明": "Explicación Concisa",
  "请输入说明": "Por favor, introduce una explicación",
  "点击选择你要链接的位置": "Haz clic para seleccionar la posición de enlace deseada",
  "跳转地址": "Dirección de Redirección",
  "最多可以添加三张": "Se permiten un máximo de tres adiciones",
  "最多添加3张优惠券": "Límite máximo de adición: 3 Cupones",
  "标题不能为空": "El Título no Puede Estar Vacío",
  "请选择跳转链接": "Selecciona la página a la que dirigir",
  "请选择优惠卷": "Selecciona un Cupón",
  "请上传图片": "Por favor, sube una imagen",
  "团购订单": "órdenes de Compra en Grupo",
  "团购管理": "Gestión de Compra en Grupo",
  "团购设置": "Configuraciones de Compra en Grupo",
  "订单设置": "Configuraciones de órdenes",
  "未支付订单": "órdenes no Pagadas",
  "请输入关闭时间": "Por favor, introduce la hora de cierre",
  "分钟后自动关闭": "Cerrar Automáticamente Después de Minutos",
  "订单下单未付款，n分钟后自动关闭，设置0不自动关闭": "Las órdenes sin pago se cerrarán automáticamente después de n minutos; establece 0 para evitar el cierre automático",
  "团购保障": "Garantía de Compra en Grupo",
  "使用门店": "Tiendas de Uso",
  "待付款": "Pendiente de Pago",
  "待使用": "Pendiente de Uso",
  "已退款": "Reembolsado",
  "使用门店名称": "Nombre de la Tienda para Uso",
  "门店联系人": "Contacto de la Tienda",
  "门店电话": "Teléfono de la Tienda",
  "团购信息": "Información de Compra en Grupo",
  "券码信息": "Información del Código del Cupón",
  "核销券码": "Canjear Código del Cupón",
  "添加团购": "Agregar Compra en Grupo",
  "团购名称": "Nombre de la Compra en Grupo",
  "销售价格": "Precio de Venta",
  "虚拟销量": "Venta Virtual",
  "部分": "Parcial",
  "基础设置": "Configuración Básica",
  "购买须知": "Directrices de Compra",
  "团购详情": "Detalles de Compra en Grupo",
  "团购须知": "Directrices de Compra en Grupo",
  "请输入团购名称": "Por favor, introduce el nombre de la compra en grupo",
  "到期类型": "Tipo de Expiración",
  "购买后生效": "Efectivo después de la Compra",
  "固定时间": "Tiempo Fijo",
  "有效天数": "Días de Validez",
  "请输入有效天数": "Por favor, introduce los días de validez",
  "有效时间": "Tiempo de Validez",
  "请输入有效时间": "Por favor, introduce el tiempo de validez",
  "团购图片": "Imagen de Compra en Grupo",
  "请上传团购图片": "Por favor, sube la imagen de compra en grupo",
  "请输入划线价格": "Por favor, introduce el precio tachado",
  "请输入销售价格": "Por favor, introduce el precio de venta",
  "请输入虚拟销量": "Por favor, proporciona la venta virtual",
  "适用门店": "Tiendas Aplicables",
  "请选择门店": "Selecciona la tienda",
  "团购状态": "Estado de Compra en Grupo",
  "每日限购数量": "Límite de Compra Diaria",
  "每个会员每日购买的最大数量，0为不限购": "Cantidad máxima que cada miembro puede comprar diariamente; 0 para sin límite",
  "商家名称": "Nombre del Comercio",
  "平台": "Plataforma",
  "满类型": "Tipo de Umbral",
  "满额": "Monto Mínimo",
  "满件数": "Cantidad Mínima",
  "满值": "Valor del Umbral",
  "减类型": "Tipo de Deducción",
  "减金额": "Cantidad a Restar",
  "打折": "Descuento",
  "减值": "Valor de Deducción",
  "编辑活动": "Editar Actividad",
  "满金额": "Monto Completo",
  "请输入满值": "Por favor, introduce el valor del umbral",
  "如果是打折，填写80，表示打8折": "Si es un descuento, escribe 80 para un 20% de descuento",
  "满额免配送费设置": "Configuración de Eliminación de Costo de Envío con el Mínimo de Compra",
  "是否开启满额免配送费": "?Activar eliminación de costo de envío con el mínimo de compra?",
  "单笔订单满": "Pedido Individual de más de",
  "如果开启满额免配送费，设置0为全场免配送费": "Si activas la eliminación de costos de envío con el monto mínimo, establece 0 para todo el envío gratuito",
  "入驻申请": "Solicitud de Registro",
  "配送订单": "órdenes de Entrega",
  "提现申请": "Solicitud de Retiro",
  "配送设置": "Configuraciones de Entrega",
  "退出申请": "Solicitud de Salida",
  "正常": "Normal",
  "押金": "Depósito",
  "累计佣金": "Comisión Acumulada",
  "可提现佣金": "Comisión Disponible para Retiro",
  "已提现佣金": "Comisión ya Retirada",
  "提现明细": "Detalles de Retiro",
  "申请条件": "Condiciones de Solicitud",
  "结算": "Liquidación",
  "是否开启押金支付": "?Habilitar Pago de Depósito?",
  "是否审核": "?Requiere Revisión?",
  "需后台审核": "Requiere Revisión de Backend",
  "无需审核": "No Requiere Revisión",
  "产品列表弹出层": "Ventana Emergente de Lista de Productos",
  "已选择该商品": "Producto ya Seleccionado",
  "注：如使用微信支付，则需申请微信支付企业付款到零钱功能": "Nota: Para pagos con WeChat, solicita la función de transferencia de la empresa a la billetera",
  "微信提现方式": "Método de Retiro de WeChat",
  "微信提现到零钱": "Retiro a la Billetera de WeChat",
  "商家转账到零钱": "Transferencias del Comerciante a la Billetera",
  "注：根据实际产品开通情况选择": "Selecciona de acuerdo a la activación actual del producto",
  "最低提现额度": "Monto Mínimo de Retiro",
  "佣金结算时间": "Tiempo de Liquidación de Comisiones",
  "注：当订单完成n小时后，该订单的配送佣金才会结算到配送员余额，如果设置为0小时，则订单完成时就结算": "Nota: Las comisiones de entrega de los pedidos se liquidan en el saldo del repartidor n horas después de completar el pedido; si se establece en 0 horas, se liquidará al finalizar el pedido",
  "请至少选择一种提现方式": "Por favor, asegúrese de seleccionar al menos un método de retiro",
  "佣金结算": "Liquidación de Comisión",
  "是否结算佣金": "?Se debe liquidar la comisión?",
  "已结算": "Liquidado",
  "未结算": "No Liquidado",
  "送达状态": "Estado de Entrega",
  "查看详情": "Ver Detalles",
  "身份证号": "Número de Identificación",
  "待交押金": "Depósito Pendiente",
  "审核方式": "Método de Revisión",
  "查看": "Inspeccionar",
  "配送员审核": "Revisión de Personal de Entrega",
  "添加外卖商品": "Agregar Productos para Llevar",
  "序号": "Número",
  "活动折扣": "Descuento Promocional",
  "活动库存": "Inventario Promocional",
  "添加店内商品": "Agregar Productos en Tienda",
  "优惠券列表": "Lista de Cupones",
  "发送优惠券": "Enviar Cupones",
  "发送对象": "Destinatario",
  "全站会员": "Miembros de Todo el Sitio",
  "指定会员": "Miembro Designado",
  "选择会员等级": "Seleccionar Nivel de Miembro",
  "发送的优惠券会员领取已达到限制数量，将不再发送给该会员": "El destinatario ha alcanzado el límite para recibir el cupón especificado y no lo recibirá más",
  "发送成功": "Enviado Exitosamente",
  "优惠券ID": "ID del Cupón",
  "优惠券名称": "Nombre del Cupón",
  "优惠券类型": "Tipo de Cupón",
  "最低消费金额": "Monto Mínimo de Gasto",
  "优惠方式": "Método de Descuento",
  "立减": "Descuento Directo",
  "打": "Descuento",
  "领取": "Recibir",
  "天内有效": "Válido por días",
  "发放总数量": "Cantidad Total de Distribución",
  "不限制": "Sin Límites",
  "已领取数量": "Cantidad Recibida",
  "修改优惠券": "Modificar Cupón",
  "请输入优惠券名称": "Por favor, introduce el nombre del cupón",
  "例如：满100减10": "Por ejemplo: Gasta 100 y obtén 10 de descuento",
  "优惠券颜色": "Color del Cupón",
  "蓝色": "Azul",
  "红色": "Rojo",
  "紫色": "Púrpura",
  "黄色": "Amarillo",
  "满减券": "Cupón de Descuento",
  "折扣券": "Cupón de Descuento por Tasa",
  "减免金额": "Monto de Reducción",
  "请输入减免金额": "Por favor, introduce el monto de reducción",
  "折扣率": "Tasa de Descuento",
  "请输入折扣率": "Por favor, introduce la tasa de descuento",
  "折扣率范围0-10，9.5代表9.5折，0代表不折扣": "La tasa de descuento va de 0 a 10. Por ejemplo, 9.5 representa un 5% de descuento, y 0 significa sin descuento",
  "请输入最低消费金额": "Por favor, introduce el monto mínimo de gasto",
  "后生效": "Efectivo después de",
  "请输入发放总数量": "Por favor, introduce la cantidad total de distribución",
  "限制领取的优惠券数量，-1为不限制": "Limita la cantidad de cupones que se pueden recibir, -1 para sin límite",
  "是否显示在领券中心": "?Se muestra en el centro de cupones?",
  "新用户首次进入小程序的时候才会显示如图所示的弹窗提示，只显示一次": "El mensaje emergente que se muestra en la imagen solo aparecerá una vez para los nuevos usuarios al entrar por primera vez al mini-programa",
  "引导收藏": "Guía de Colección",
  "编辑类型": "Editar Tipo",
  "生日设置": "Configuración de Cumpleaños",
  "手机短信": "SMS de Teléfono",
  "分销商用户": "Usuario Distribuidor",
  "分销订单": "Pedidos de Distribución",
  "分销海报": "Carteles de Distribución",
  "推荐人": "Referente",
  "下级用户": "Usuarios Subordinados",
  "一级": "Nivel Uno",
  "二级": "Nivel Dos",
  "三级": "Nivel Tres",
  "成为时间": "Fecha de Afiliación",
  "下级": "Subordinado",
  "加入时间": "Fecha de Incorporación",
  "分销商条件": "Condiciones de Distribuidor",
  "佣金设置": "Configuración de Comisión",
  "自定义文字": "Texto Personalizado",
  "申请协议": "Acuerdo de Solicitud",
  "页面背景图": "Imagen de Fondo de Página",
  "分销中心页面": "Página del Centro de Distribución",
  "页面标题": "Título de Página",
  "分销中心": "Centro de Distribución",
  "非分销商提示": "Aviso para No Distribuidores",
  "您还不是分销商，请先提交申请": "Todavía no es un distribuidor, por favor, envíe una solicitud primero",
  "申请成为分销商": "Solicitud para ser Distribuidor",
  "立即加入": "Unirse Ahora",
  "可提现": "Disponible para Retiro",
  "待提现佣金": "Comisión Pendiente de Retiro",
  "待提现": "Pendiente de Retiro",
  "已提现金额": "Cantidad Total Retirada",
  "去提现": "Retirar Ahora",
  "申请成为分销商页面": "Página de Solicitud para ser Distribuidor",
  "请填写申请信息": "Por favor, complete la información de solicitud",
  "分销商申请协议": "Acuerdo de Solicitud de Distribuidor",
  "申请成为经销商": "Solicitar ser Distribuidor",
  "审核中提示信息": "Notificación de Revisión en Progreso",
  "您的申请已受理，正在进行信息核验，请耐心等待。": "Su solicitud ha sido recibida y se está verificando la información. Por favor, espere pacientemente",
  "去商城逛逛": "Ir de Compras en el Centro Comercial",
  "分销订单页面": "Página de Pedidos de Distribución",
  "我的团队页面": "Página de Mi Equipo",
  "团队总人数": "Número Total de Miembros del Equipo",
  "一级团队": "Equipo Primario",
  "二级团队": "Equipo Secundario",
  "三级团队": "Equipo Terciario",
  "提现明细页面": "Página de Detalles de Retiro",
  "审核中": "En Revisión",
  "申请提现页面": "Página de Solicitud de Retiro",
  "申请提现": "Enviar Solicitud de Retiro",
  "请输入要提取的金额": "Por favor, introduce la cantidad de retiro deseada",
  "最低提现佣金": "Comisión Mínima de Retiro",
  "提交申请": "Enviar Solicitud",
  "佣金结算天数": "Días de Liquidación de Comisión",
  "注：当订单完成n天后，该订单的分销佣金才会结算到分销商余额，如果设置为0天,则订单完成时就结算": "Nota: La comisión de un pedido completado se liquidará al saldo del distribuidor después de n días. Si se establece en 0 días, se liquidará al completar el pedido",
  "成为分销商条件": "Condiciones de Distribuidor",
  "购买指定商品成为分销商": "Conviértete en un distribuidor comprando productos designados",
  "购买指定商品付款后自动成为分销商，无需后台审核": "Conviértete automáticamente en distribuidor después de comprar productos designados, sin necesidad de revisión en el backend",
  "选择商品": "Seleccionar Productos",
  "成为下线条件": "Criterios para Convertirse en Subordinado",
  "首次点击分享链接": "Primer clic en el enlace compartido",
  "一级佣金比例": "Tasa de Comisión Primaria",
  "佣金比例范围 0% - 100%": "Rango de tasa de comisión 0% - 100%",
  "二级佣金比例": "Tasa de Comisión Secundaria",
  "三级佣金比例": "Tasa de Comisión Terciaria",
  "是否开启分销功能": "Activar Función de Distribución",
  "分销层级": "Niveles de Distribución",
  "一级分销": "Distribución Primaria",
  "二级分销": "Distribución Secundaria",
  "三级分销": "Distribución Terciaria",
  "分销商内购": "Compra Interna del Distribuidor",
  "如开启，分销商自己购买商品，获得一级佣金": "Si está habilitado, los distribuidores reciben comisión primaria por sus compras",
  "分销中心首页": "Página de Inicio del Centro de Distribución",
  "尺寸：宽750像素 高度227像素": "Dimensiones: Ancho 750 píxeles, Alto 227 píxeles",
  "申请成为分销商页": "Página para Solicitar Convertirse en Distribuidor",
  "申请提现页": "Página de Solicitud de Retiro",
  "分销海报设置": "Configuraciones de Póster de Distribución",
  "海报背景图": "Imagen de Fondo del Póster",
  "尺寸：宽750像素 高大于(等于)1200像素": "Dimensiones: Ancho 750 píxeles, Alto mayor o igual a 1200 píxeles",
  "头像宽度": "Ancho de Avatar",
  "头像样式": "Estilo de Avatar",
  "正方形": "Cuadrado",
  "圆形": "Circular",
  "昵称字体大小": "Tamaño de Fuente de Apodo",
  "昵称字体颜色": "Color de Fuente de Apodo",
  "小程序码宽度": "Ancho de Código de Mini Programa",
  "小程序码样式": "Estilo de Código de Mini Programa",
  "分销商": "Distribuidor",
  "一级分销商": "Distribuidor Primario",
  "分销佣金": "Comisión del Distribuidor",
  "二级分销商": "Distribuidor Secundario",
  "三级分销商": "Distribuidor Terciario",
  "分销商审核": "Revisión de Distribuidor",
  "积分明细": "Detalles de Puntos",
  "变动数量": "Cambios de Cantidad",
  "积分名称": "Nombre de Puntos",
  "例": "Ejemplo",
  "修改积分名称后，在买家端的所有页面里，看到的都是自定义的名称": "Después de modificar el nombre de los puntos, el nombre personalizado se mostrará en todas las páginas del comprador",
  "商家使用自定义的积分名称来做品牌运营。如京东把积分称为“京豆”，淘宝把积分称为“淘金币”": "Las empresas utilizan nombres de puntos personalizados para el branding. Por ejemplo, JD llama a los puntos 'JD Beans' y Taobao los llama 'Treasure Coins'",
  "积分说明": "Descripción de Puntos",
  "积分赠送": "Entrega de Puntos",
  "是否开启购物送积分": "Activar Puntos por Compras",
  "积分赠送规则": "Reglas de Entrega de Puntos",
  "如开启则订单完成后赠送用户积分": "Si está habilitado, se otorgan puntos a los usuarios al completar la orden",
  "订单确认收货已完成": "Confirmación y recepción de la orden completadas",
  "已完成订单超出后台设置的申请售后期限": "Las órdenes completadas exceden el período de postventa configurado en el backend",
  "积分赠送比例": "Ratio de Entrega de Puntos",
  "赠送比例请填写数字0~100；订单的运费不参与积分赠送": "Por favor, introduce una proporción entre 0 y 100; los gastos de envío no se incluyen en la entrega de puntos",
  "订单付款金额(100.00€) * 积分赠送比例(100%) = 实际赠送的积分(100积分)": "Monto de pago de la orden (100.00€) * Ratio de Entrega de Puntos (100%) = Puntos otorgados reales (100 puntos)",
  // =====================  营销工具end   ==========

  // =====================  数据统计 start   ==========
  "销售统计": "Estadísticas de Ventas",
  "会员统计": "Estadísticas de Miembros",
  "订单概况": "Resumen de Pedidos",
  "商品概况": "Resumen de Productos",
  "今日": "Hoy",
  "累积会员数": "Total de Miembros",
  "新增会员数": "Nuevos Miembros",
  "成交会员数": "Miembros transaccionales",
  "排行榜": "Tablero de Posiciones",
  "用户消费榜": "Ranking de Gasto de Usuarios",
  "积分排行榜": "Ranking de Puntos",
  "邀请人排行榜": "Ranking de Invitadores",
  "成交会员占比": "Proporción de Miembros Transaccionales",
  "今天": "Hoy",
  "最近7天": "últimos 7 Días",
  "最近30天": "últimos 30 Días",
  "最近90天": "últimos 90 Días",
  "最近180天": "últimos 180 Días",
  "最近1年": "último año",
  "最近2年": "últimos 2 Años",
  "所有占比": "Proporción General",
  "成交会员": "Miembros Transaccionales",
  "未成交会员": "Miembros No Transaccionales",
  "新增会员": "Nuevos Miembros",
  "最近一周": "última Semana",
  "最近一个月": "último Mes",
  "最近三个月": "últimos tres meses",
  "选择店铺": "Seleccionar tienda",
  "查询日期": "Fecha de consulta",
  "近七天": "últimos siete días",
  "近十五天": "últimos quince días",
  "自定义时间": "Tiempo personalizado",
  "日期": "Fecha",
  "有效订单数": "Cantidad de Pedidos Válidos",
  "选择时间": "Seleccionar tiempo",
  "交易统计": "Estadísticas de Transacciones",
  "订单数": "Número de Pedidos",
  "客单价": "Valor Promedio por Pedido",
  "付款订单": "Pedidos Pagados",
  "付款人数": "Número de Clientes que Pagan",
  "商品统计": "Estadísticas de Productos",
  "在售商品": "Productos Disponibles",
  "件": "Artículo",
  "已付款商品": "Productos Pagados",
  "销量TOP10": "Top 10 de Ventas",
  "浏览TOP10": "Top 10 de Vistas",
  "浏览": "Vista",
  "排行类型": "Tipo de Ranking",
  "商品总数": "Número Total de Productos",
  "已上架商品": "Productos en Estantería",
  "已下架商品": "Productos Fuera de Estantería",
  "商品导出": "Exportación de Productos",
  "商品总销量": "Ventas Totales de Productos",
  "商品总销售额": "Monto Total de Ventas de Productos",
  "资产总览": "Visión General de Activos",
  "财务对账": "Conciliación Financiera",
  "交易记录": "Registros de Transacciones",
  "店铺结算": "Liquidación de Tienda",
  "待结算金额": "Monto Pendiente de Liquidación",
  "已结算金额": "Monto Liquidado",
  "交易概况": "Resumen de Transacciones",
  "外卖统计": "Estadísticas de Entrega a Domicilio",
  "店内统计": "Estadísticas en Tienda",
  "订单类型": "Tipo de Pedido",
  "应收金额": "Monto a Recibir",
  "实付金额": "Monto Pagado",
  "账户概况": "Visión General de la Cuenta",
  "订单编号": "Número de Pedido",
  "支付状态": "Estado de Pago",
  "付款方式": "Método de Pago",
  "订单费用": "Costo del Pedido",
  "优惠": "Descuento",
  "商户实际收入": "Ingresos Reales del Comerciante",
  "商品ID": "ID de Producto",
  "小计": "Subtotal",
  "请输入提现金额": "Por favor ingresa la cantidad a retirar",
  "请输入打款方式": "Por favor ingresa el método de pago",
  "支付宝真实姓名": "Nombre Real de Alipay",
  "请输入支付宝真实姓名": "Por favor ingresa el nombre real de Alipay",
  "开户行名称": "Nombre del Banco",
  "银行开户名": "Nombre de la Cuenta Bancaria",
  "真实姓名": "Nombre Real",
  "应付金额": "Monto a Pagar",
  "实付总额": "Monto Total Pagado",
  "商户": "Comerciante",
  "结算金额": "Monto de Liquidación",
  "店铺结算金额": "Monto de Liquidación de Tienda",
  "操作提示": "Consejos de Operación",
  "订单结算金额 = 店铺结算总金额(含运费)": "Monto de Liquidación de Pedido = Monto de Liquidación Total de la Tienda (incluido el costo de envío)",
  "店铺收入金额 = 店铺结算总金额 - 店铺退款金额": "Ingresos de la Tienda = Monto de Liquidación Total de la Tienda - Monto de Reembolso de la Tienda",
  "订单日期": "Fecha del Pedido",
  "订单结算金额": "Monto de Liquidación de Pedido",
  "配送费金额": "Monto de Tarifa de Envío",
  "商品编码": "Código de Producto",
  "可用余额": "Saldo Disponible",
  "提现概况": "Visión General del Retiro",
  "搜索": "Buscar",
  "支出": "Gasto",
  "金额": "Cantidad",
  "收支类型": "Tipo de Ingresos y Gastos",
  "确认要退吗?": "Confirmar la Devolución?",
  "申请成功": "Solicitud Exitosa",
  "门店总金额": "Monto Total de la Tienda",
  "累计收入": "Ingresos Acumulados",
  "访客数": "Número de Visitantes",
  "访问量": "Volumen de Visitas",
  "店铺收藏数": "Cantidad de Favoritos de la Tienda",
  "商品收藏数": "Cantidad de Favoritos de Productos",
  "访问数": "Número de Visitas",
  "收藏数": "Número de Favoritos",
  "数": "Número",
  "待支付": "Pago Pendiente",
  "实际到账": "Cantidad Realmente Recibida",
  // =====================  数据统计 end   ==========

  // ==================== 设置 start ================
  "物流公司": "Empresa de Logística",
  "chatgpt设置": "Configuración de ChatGPT",
  "消息设置": "Configuración de Mensajes",
  "短信设置": "Configuración de SMS",
  "上传设置": "Configuración de Subida",
  "清理缓存": "Limpiar Caché",
  "网址后缀英文名称": "Nombre en Inglés para el Sufijo del Sitio Web",
  "英文名称": "Nombre en Inglés",
  "默认头像": "Avatar Predeterminado",
  "英文名称必须只包含数字和英文字母": "El Nombre en Inglés solo debe contener números y letras",
  "恭喜你，商城设置成功": "Felicidades, la configuración de la tienda se ha aplicado exitosamente",
  "表单数据不符合规则": "Los datos del formulario no cumplen con las reglas",
  "剩余额度": "Límite Restante",
  "余额不足时，智能客服、AI魔法创建、多语言翻译等功能将无法使用": "Cuando el saldo sea insuficiente, funciones como Servicio al Cliente Inteligente, Creación Mágica de IA y Traducción Multilingüe estarán desactivadas",
  "使用明细": "Detalles de Uso",
  "消费": "Gasto",
  "额度": "Cupo",
  "数据缓存": "Caché de Datos",
  "恭喜你，清理成功": "Felicidades, el proceso de limpieza fue exitoso",
  "管理员列表": "Lista de Administradores",
  "角色管理": "Gestión de Roles",
  "登录日志": "Registro de Inicio de Sesión",
  "操作日志": "Registro de Operaciones",
  "添加管理员": "Agregar Administrador",
  "管理员ID": "ID de Administrador",
  "用户名": "Nombre de Usuario",
  "所属角色": "Rol Asignado",
  "超级管理员": "Super Administrador",
  "所属门店": "Tienda Afiliada",
  "门店状态": "Estado de la Tienda",
  "已删除": "Eliminado",
  "未删除": "No Eliminado",
  "账号状态": "Estado de la Cuenta",
  "恭喜你，该管理员删除成功": "Felicidades, el administrador ha sido eliminado exitosamente",
  "请输入用户名": "Por favor ingresa el nombre de usuario",
  "修改管理员": "Editar Administrador",
  "添加角色": "Agregar Rol",
  "角色ID": "ID de Rol",
  "角色名称": "Nombre de Rol",
  "恭喜你，该角色删除成功": "Felicidades, el rol ha sido eliminado exitosamente",
  "编辑角色": "Editar Rol",
  "请输入角色名称": "Por favor ingresa el nombre del rol",
  "权限列表": "Lista de Permisos",
  "请输入用户名和真实姓名": "Por favor ingresa el nombre de usuario y el nombre real",
  "登录状态": "Estado de Inicio de Sesión",
  "全部标记为已读": "Marcar Todos como Leídos",
  "公告详情": "Detalles del Aviso",
  "全部标记为已读消息吗?": "Marcar todos los mensajes como leídos?",
  "操作成功!": "Operación exitosa!",
  "已取消操作": "Operación cancelada",
  "订单流程设置": "Configuración del Proceso de Pedidos",
  "已支付订单": "Pedidos Pagados",
  "分钟后自动核销": "validar automáticamente después de minutos",
  "如果在期间未核销，系统自动完成核销，设置0不自动核销": "Si no se valida dentro del período, el sistema validará automáticamente, configurar en 0 para no validar automáticamente",
  "积分商城订单流程设置": "Configuración del Proceso de Pedidos del Centro Comercial de Puntos",
  "已发货订单": "Pedidos Enviados",
  "天后自动核销": "validar automáticamente después de días",
  "不包括桌台订单": "excluyendo pedidos de mesa",
  "恭喜你，交易设置成功": "Felicidades, la configuración de transacciones se ha aplicado exitosamente",
  // ==================== 设置 end ================
  // ==================== Layout start ===========
  "当前版本": "Versión Actual",
  "试用版": "Versión de Prueba",
  "专业版": "Edición Profesional",
  "高级版": "Edición Avanzada",
  "至尊版": "Edición Suprema",
  "到期日期": "Fecha de Caducidad",
  "永不过期": "Nunca Caduca",
  "欢迎您": "Bienvenido",
  "修改密码": "Cambiar Contraseña",
  "此操作将退出登录, 是否继续?": "Esta operación cerrará su sesión, ?desea continuar?",
  "原始密码": "Contraseña Original",
  "新密码": "Nueva Contraseña",
  "确认新密码": "Confirmar Nueva Contraseña",
  "系统公告": "Anuncio del Sistema",
  "请至少选择一件产品商品！": "Por favor seleccione al menos un producto!",
  "超链接设置": "Configuración de Hipervínculo",
  "图像预览": "Vista Previa de la Imagen",
  "页面": "Página",
  "当前链接": "Enlace Actual",
  "暂无": "Ninguno",
  "页面路径": "Ruta de la Página",
  "注意一": "Nota Uno",
  "注意二": "Nota Dos",
  "注意三": "Nota Tres",
  "同一个小程序链接其他小程序，最多只能链接10个，超过将不生效": "Para el mismo mini-programa enlazar a otros mini-programas, se permite un máximo de 10 enlaces; superar este límite los volverá ineficaces",
  "不能填写自身小程序appid": "No se puede completar con el appid del mini programa actual",
  "小程序链接留空默认跳到小程序首页": "Dejar en blanco el enlace del mini-programa lo llevará automáticamente a la página principal del mini-programa",
  "分类": "Categoría",
  "选择": "Seleccionar",
  "签到": "Registrarse",
  "积分商城": "Centro Comercial de Puntos",
  "秒杀": "Venta Express",
  "拼团": "Compra en Grupo",
  "砍价": "Regateo",
  "领券中心": "Centro de Cupones",
  "生日有礼": "Regalo de Cumpleaños.",
  "链接的网页必须支持SSL ，链接必须以 https:// 开头，否则无法跳转": "La página web enlazada debe ser compatible con SSL y comenzar con https://, de lo contrario no se podrá redirigir",
  "链接的域名必须是备案域名，否则无法跳转": "El nombre de dominio enlazado debe estar registrado, de lo contrario no se podrá redirigir",
  "您的网站域名必须加到微信小程序公众平台的业务域名处,详细说明？": "Su nombre de dominio de sitio web debe agregarse al dominio comercial de la Plataforma Pública del Mini Programa de WeChat, ?puede proporcionar más detalles?",
  "选择文章列表": "Seleccionar Lista de Artículos",
  "文章标题": "Título del Artículo",
  "选择规格": "Seleccionar Especificaciones",
  "产品/规格": "Producto/Especificaciones",
  "已选": "Seleccionado",
  "查看物流": "Ver Logística",
  "请输入收货人": "Por favor ingrese el destinatario",
  "请输入收获电话": "Por favor ingrese el teléfono del destinatario",
  "省": "Provincia",
  "市": "Ciudad",
  "区": "Distrito",
  "现金收款": "Pago en Efectivo",
  "余额收款": "Pago con Saldo",
  "其他方式": "Otros Métodos",
  "请输入会员ID号查询会员，输入完毕后点击确认": "Por favor ingrese el ID del miembro para buscar al miembro, luego haga clic en confirmar cuando termine",
  "请输入会员ID": "Por favor ingrese el ID del miembro",
  "会员昵称": "Apodo del Miembro",
  "余额总计": "Saldo Total",
  "登录会员仅作为积分累计，无法享受其他优惠": "Los miembros registrados solo pueden acumular puntos y no pueden disfrutar de otros descuentos",
  "取消收款": "Cancelar Pago",
  "收款": "Recibir Pago",
  "请输入会员手机号": "Por favor ingrese el número de teléfono del miembro",
  "该用户不存在": "Este usuario no existe",
  "注册": "Registro",
  "平台名称": "Nombre de la Plataforma",
  "请输入平台名称": "Por favor ingrese el nombre de la plataforma",
  "所在地区": "Ubicación",
  "请选择所在地区": "Por favor seleccione la ubicación",
  "平台账户名": "Nombre de Cuenta de la Plataforma",
  "请输入平台账户名": "Por favor ingrese el nombre de cuenta de la plataforma",
  "平台账户密码": "Contraseña de la Cuenta de la Plataforma",
  "是否连锁": "Es una cadena?",
  "是": "Sí",
  "否": "No",
  "请输入您的地址": "Por favor ingrese su dirección",
  "请输入您的联系电话": "Por favor ingrese su número de teléfono de contacto",
  "请输入您的联系邮箱": "Por favor ingrese su correo electrónico de contacto",
  "联系邮箱": "Correo Electrónico de Contacto",
  "不能全是空格": "No puede contener solo espacios",
  "不能包含空格": "No puede contener espacios",
  "长度不能小于6位": "La longitud no puede ser menor a 6 caracteres",
  "请填写确认密码": "Por favor ingrese la contraseña de confirmación",
  "确认密码不一致": "Las contraseñas no coinciden",
  "联系电话和联系邮箱至少填写一个": "Por favor proporcione al menos un número de teléfono de contacto o correo electrónico",
  "注册成功,请前往登录": "Registro exitoso, por favor proceda a iniciar sesión",
  "清空": "Limpiar",
  "确认": "Confirmar",
  "限时免费": "Gratis por Tiempo Limitado",
  // ==================== Components end     =========

  // ==================== 其它  start  ================
  '菜品总量': 'Cantidad total de platos',
  '菜品排行榜': 'Lista de clasificación de platos',
  '商家信息': 'Información del comerciante',
  '与店内营业时间相同': 'Igual que el horario de apertura del local',
  '菜品': 'Platos',
  '菜品分类': 'Categorización de platos',
  '添加菜品': 'Añadir un plato',
  '通告': 'Aviso',
  '商家店名': 'Nombre de la tienda',
  '请输入商家店名': 'Por favor, introduce el nombre de tu tienda',
  '温馨提示：选择后，请勿随意修改，以免造成门店菜品数据错乱': 'Consejo amable: Una vez seleccionado, evite modificarlo aleatoriamente para evitar confusiones en los datos de los platos de la tienda',
  '网址后缀设置': 'Configuración de sufijo de URL',
  '选填，设置后缀可替换下列网址末尾的数字id，方便记忆': 'Opcional, establecer un sufijo puede reemplazar el ID numérico al final de la URL a continuación, facilitando así su memorización',
  '网址设置': 'Configuración de URL',
  '手机网站二维码': 'Código QR del sitio web móvil',
  '按菜品收费': 'Facturación por plato',
  '外卖菜品': 'Platos para llevar',
  '店内菜品': 'Platos para consumir en el local',
  '菜品管理': 'Gestión de platos',
  '菜品名称': 'Nombre del plato',
  '请输入菜品名称': 'Por favor, introduce el nombre del plato',
  '此菜品正在参加活动，不能修改规格': 'Este plato está participando en una promoción y no se puede modificar en cuanto a las especificaciones',
  '通过人工智能技术，可以根据菜品名称自动填写菜品详细信息，如配料、卖点、口味等。': 'A través de la tecnología de inteligencia artificial, es posible completar automáticamente los detalles del plato, como ingredientes, puntos de venta, sabores, según el nombre del plato.',
  '请填写菜品详情': 'Por favor, completa los detalles del plato',
  '菜品详情': 'Detalles del plato',
  '菜品图片': 'Imagen del plato',
  '请上传菜品图片': 'Por favor, sube una imagen del plato',
  'AI未识别到您的菜品图片': 'El sistema de IA no pudo reconocer la imagen de tu plato',
  '本菜品正在参加活动，不能删除规格！': 'Este plato está participando en una promoción y no se pueden eliminar las especificaciones',
  '菜品加料': 'Ingredientes adicionales del plato',
  '菜品状态': 'Estado del plato',
  '选择菜品状态': 'Seleccionar estado del plato',
  '菜品排序': 'Ordenar los platos',
  '请填写菜品名称': 'Por favor, introduce el nombre del plato',
  '你选择菜品分类': 'Has elegido una categoría de platos',
  '菜品卖点': 'Atractivo del plato',
  '菜品属性': 'Atributos del plato',
  '菜品同步': 'Sincronización de platos',
  '是否同步菜品至外卖': 'Sincronizar platos para pedidos a domicilio',
  '是否同步菜品至店内': 'Sincronizar platos para consumir en el local',
  '搜索菜品': 'Buscar platos',
  '菜品原价': 'Precio original del plato',
  '菜品来源': 'Origen del plato',
  '菜品列表': 'Lista de platos',
  '菜品价格': 'Precio del plato',
  '菜品销量': 'Venta de platos',
  '通告管理': 'Gestión de avisos',
  '添加通告': 'Añadir un aviso',
  '通告ID': 'ID del aviso',
  '通告标题': 'Título del aviso',
  '通告分类': 'Categoría del aviso',
  '通告排序': 'Orden de los avisos',
  '通告状态': 'Estado del aviso',
  '通告内容': 'Contenido del aviso',
  '编辑通告': 'Editar aviso',
  'AI助理形象选择': 'Selección de la imagen del asistente de IA',
  '菜品信息': 'Información del plato',
  '菜品总价': 'Precio total de los platos',
  '请按实际店名填写，将显示在商家点餐网站上': 'Por favor, introduce el nombre real de la tienda, que se mostrará en el sitio web de pedidos del comerciante',
  '首次添加桌位请先添加桌位类型': 'Por favor, añade primero un tipo de mesa al agregar una mesa por primera vez',
  '首次添加桌位请先添加区域': 'Por favor, añade primero un área al agregar una mesa por primera vez',
  '设置店内区域，如A区、B区、大厅、包厢等': 'Configurar áreas dentro del local, como área A, área B, Salón, Sala privada, etc.',
  '设置桌位类型，如二人桌、四人桌、大桌、小桌等': 'Configurar tipos de mesas, como mesa para dos, mesa para cuatro, mesa grande, mesa pequeña, etc.',
  '该账号用于登录收银台网站（可在“网址设置”页面找到收银台网址）': 'Esta cuenta se utiliza para iniciar sesión en el sitio web del punto de venta (se puede encontrar el enlace al sitio de punto de venta en la página de "Configuración de URL")',
  '该账号用于登录后厨网站（可在“网址设置”页面找到后厨网址）': 'Esta cuenta se utiliza para iniciar sesión en el sitio web de la cocina (se puede encontrar el enlace al sitio de la cocina en la página de "Configuración de URL")',
  '如无需设置税率可不填写': 'Si no es necesario establecer una tasa impositiva, deja este campo en blanco',
  '打款信息': 'Información de pago',
  '开户行': 'Nombre del banco',
  '菜品分组': 'Agrupación de platos',
  '自定义名称，仅用于商家自己区分分类，不会展示给顾客': 'Nombre personalizado, solo para la distinción interna de categorías por parte del comerciante y no se mostrará a los clientes',
  '手机网站编辑': 'Edición del sitio web móvil',
  '恢复初始默认页面': 'Restablecer la página predeterminada inicial',
  '通告为手机网站上展示的通知、公告、商家介绍等，“显示”状态时，该篇通告将展示在手机网站上': "Los avisos son notificaciones, anuncios, presentaciones comerciales, etc., mostrados en el sitio web móvil. Cuando estén en modo 'visualización', estos avisos se mostrarán en el sitio web móvil",
  '该操作 将使用微信支付企业付款到零钱功能，确定打款吗？': '?Esta operación utilizará la función de transferencia empresarial de WeChat para enviar fondos directamente a la billetera electrónica, ?confirmar la transferencia de fondos?',
  '菜品重量': 'Peso del plato',
  '请填写菜品重量': 'Por favor, indica el peso del plato',
  '菜品设置': 'Configuración del plato',
  '已选择该菜品': 'Has seleccionado este plato',
  '添加外卖菜品': 'Añadir platos para llevar',
  '添加店内菜品': 'Añadir platos para consumir en el local',
  '我的团队': 'Mi equipo',
  '购买指定菜品成为分销商': 'Comprar ciertos platos para convertirse en distribuidor',
  '购买指定菜品付款后自动成为分销商，无需后台审核': 'Al comprar ciertos platos y hacer el pago, se convertirá automáticamente en distribuidor, sin necesidad de aprobación posterior',
  '选择菜品': 'Seleccionar platos',
  '如开启，分销商自己购买菜品，获得一级佣金': 'Si está activado, los distribuidores pueden comprar los platos por sí mismos y obtener una comisión de primer nivel',
  '订单付款金额(100.00€) * 积分赠送比例(100%) = 实际赠送的积分(100积分)”': 'Monto de pago del pedido (100.00€) * Proporción de bonificación en puntos (100%) = Puntos otorgados efectivamente (100 puntos)',
  '菜品概况': 'Resumen de los platos',
  '菜品统计': 'Estadísticas de los platos',
  '在售菜品': 'Platos en venta',
  '已付款菜品': 'Platos pagados',
  '菜品总数': 'Número total de platos',
  '已上架菜品': 'Platos en stock',
  '已下架菜品': 'Platos fuera de stock',
  '菜品导出': 'Exportar platos',
  '菜品总销量': 'Cantidad total de ventas de platos',
  '菜品总销售额': 'Ingresos totales de ventas de platos',
  '菜品ID': 'ID del plato',
  '菜品编码': 'Código del plato',
  '菜品收藏数': 'Número de veces que el plato ha sido guardado en favoritos',
  '请至少选择一件产品菜品！': '?Por favor, selecciona al menos un plato de producto!',
  "区域管理": "Gestión de Área",
  "点餐管理系统": "Sistema de Gestión de Pedidos",
  "首页": "Página de Inicio",
  "在地图中点击确认位置，坐标自动填入":"Haz clic para confirmar la ubicación en el mapa, y las coordenadas se completarán automáticamente.",
  "添加优惠券请前往'营销工具'—'插件中心'—'优惠券'页面":"Para agregar un cupón, por favor ve a 'Marketing' - 'Herramientas de marketing' - 'Cupón'.",
  // ==================== 其它  end    ================
  ...esLocale
}


export default es



// WEBPACK FOOTER //
// ./src/i18n/langs/es.js